// ID generator:
// https://www.random.org/strings/?num=1&len=8&digits=on&upperalpha=on&loweralpha=on&unique=on&format=html&rnd=new

const events = [
  // {
  //   id: "",
  //   title: "",
  //   dateTime: "YYYY-MM-DDTHH:MM:00+02:00",
  //   dateTimeFrom: "",
  //   dateTimeTo: "",
  //   location: "",
  //   summary: "",
  //   banner: process.env.PUBLIC_URL + "banner.jpg",
  //  description: `
  //    <p>
  //    </p>
  //    <p class="mt-5">
  //    </p>
  //   `,
  //   agenda: [
  //     {
  //       title: "",
  //       dateTime: "YYYY-MM-DDTHH:MM:00+02:00",
  //       description: `
  //       `,
  //     },
  //   ],
  //   programDirectors: [
  //     {
  //       name: '',
  //       image: process.env.PUBLIC_URL + 'directors/',
  //       profileURL: '',
  //       position: '',
  //       bio: ""
  //     },
  //   ],
  //   speakers: null,
  //   targetAudience: `
  //   `,
  //   videos: [],
  //   photos: [],
    // organizers: [
    //   {
    //     name: "",
    //     link: "",
    //     logo: process.env.PUBLIC_URL + "/img/partners/",
    //   },
    // ],
  //   partners: [
  //     {
  //       name: "",
  //       link: "",
  //       logo: process.env.PUBLIC_URL + "/img/partners/",
  //     },
  //   ],
  //   sponsors: [],
  // },
  {
    id: "slSvOTyO",
    title: "Beyond the Summit: The Future of EU-Africa Trade and Investment in a Shifting Geopolitical Landscape",
    dateTime: "2026-01-29T09:30:00+02:00",
    location: "Sofitel Brussels Europe, Place Jourdan 1, 1040 Brussels",
    summary: "This exclusive event marked an important moment following the 7th EU-AU Summit in Luanda, Angola, underscoring the evolving dynamics shaping the partnership between Africa and the European Union.",
    banner: process.env.PUBLIC_URL + "banner.jpg",
    description: `
      <p>
        The Brussels-Africa Hub recently partnered with <a href="https://discover.ie.edu/corporate/landing/master/grouper/pathway/business-and-management/masters-bmng" target="_blank" rel="noopener noreferrer" class="text-blue-500">IE University</a> to host a roundtable titled "Beyond the Summit: The Future of EU-Africa Trade and Investment in a Shifting Geopolitical Landscape," on January 29 in Brussels.  
      </p>
      <p class="mt-5">
        This exclusive event marked an important moment following the 7th EU-AU Summit in Luanda, Angola, underscoring the evolving dynamics shaping the partnership between Africa and the European Union.
      </p>
      <p class="mt-5">
        Bringing together diplomats, business leaders, and financial experts, the discussion focused on how global geopolitical and economic shifts are reshaping investment flows and strategic priorities. With bilateral trade hitting €355 billion in 2024 and European FDI stock in Africa surpassing €239 billion, the conversation underscored the urgent need for innovative financing solutions.
      </p>
      <p class="mt-5">
        Keynote remarks by <b>H.E. Javier Nino Perez, EU Ambassador to the African Union</b>, framed the summit’s outcomes and their impact on trade and investment. The dialogue featured <b>H.E. Philip Bob Jusu, Ambassador of Sierra Leone</b>, and <b>Dr. Slim Feriani, Founding Partner of Alternative Path Partners</b>, both bringing deep expertise in public policy, private sector innovation, and investment management.
      </p>
      <p class="mt-5">
        They explored critical themes including the EU’s ability to sustain its leadership in African investment, the potential of coalition-based investment models to bridge financing gaps, and the sectors best positioned for growth amid shifting global dynamics.
      </p>
      <p class="mt-5">
        This discussion reaffirmed the Brussels Africa Hub’s commitment to connecting Europe and Africa’s financial ecosystems. It also highlighted the ongoing need for active collaboration among investors, policymakers, and financial institutions to transform high-level Summit commitments into tangible, impactful partnerships across both continents.
      </p>
      <p class="mt-5">
        The evolving global landscape presents an unprecedented opportunity to deepen collaboration between EU and African capital markets. See our <a href="https://files.brusselsafricahub.eu/global-gateway-policy-paper.pdf" target="_blank" rel="noopener noreferrer" class="text-blue-500">position paper on the Global Gateway</a> and how capital markets are pivotal to driving its successful implementation.
      </p>
    `,
    agenda: [
      {
        title: "Welcome and opening remarks",
        dateTime: "2026-01-29T09:30:00+01:00",
        description: `
          <ul class="list-disc pl-5">
            <li>Eniola Harrison, Director, IE Africa Center</li>
          </ul>`,
      },
      {
        title: "Keynote addresses: \"Key outcomes of the 7th AU-EU Summit - Implications for Trade and Investment\"",
        dateTime: "2026-01-29T09:45:00+01:00",
        description: `
          <ul class="list-disc pl-5">
            <li>Javier Nino Perez, EU Ambassador to the AU</li>
            <li>Ambassador Ali Yakoub MAHAMOUD, African Union Permanent Representative to the EU and OACPS</li>
          </ul>`,
      },
      {
        title: "Panel discussion and Q&A: EU-Africa Investment in a Changing Global Order",
        dateTime: "2026-01-29T10:15:00+01:00",
        description: `
          Moderator: Prof. Grace Obado, IE University
          <ul class="list-disc pl-5">
            <li>Elisabeth Moreno, Chairwoman, Ring Capital</li>
            <li>Dr Slim Feriani, former Minister of Industry, Energy, Mining, Renewable Energy & SMEs (Tunisia) and former CEO of the Sovereign Wealth Fund of Djibouti</li>
            <li>Ms Luisa Santos, Deputy Director General, Business Europe</li>
          </ul>`,
      },
      {
        title: "Closing remarks",
        dateTime: "2026-01-29T11:15:00+01:00",
        description: `
          <ul class="list-disc pl-5">
            <li>Mouctar Bah, Executive Chairman, Brussels-Africa Hub</li>
          </ul>`,
      },
      {
        title: "Networking and refreshments",
        dateTime: "2026-01-29T11:30:00+01:00",
      },
    ],
    photos: ["12ec738e-6764-45e2-806c-5299d3be55ba.jpeg","4a3e8665-ffc2-4d4e-8d51-4ad2f857fd03.jpeg","5a88a8f9-64ab-4612-852d-fcc92036aeec.jpeg","8e380258-e018-47bf-942a-e16c3c42899e.jpeg","b8f68da3-d658-45dd-b840-daf8969282c0.jpeg","c61f4e92-5296-4647-a24d-b2d3bc90f1f9.jpeg","c8e53610-976c-4e45-a5c9-c836a9e731b3.jpeg"],
    organizers: [
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
      {
        name: 'IE University',
        link: 'https://www.ie.edu/university/',
        logo: process.env.PUBLIC_URL + '/img/partners/ie-university.png',
      }
    ],
  },
  {
    id: "hNFs8Zou",
    title: "Diplomatic Breakfast Roundtable - Strategic Dialogue: AI, Geo-Economics, and the Future of Europe-Africa Value Chain Partnerships",
    dateTime: "2025-10-10T08:30:00+02:00",
    location: "TheMerode, Place Poelaert 6, 1000 Brussels",
    summary: "A closed-door dialogue exploring how artificial intelligence and digitalisation can shape a transformative Africa–Europe partnership, grounded in mutual sovereignty and shared prosperity",
    banner: process.env.PUBLIC_URL + "banner.jpg",
    description: `
      <p>
        The <b>Brussels-Africa Hub</b>, in partnership with <b>Africa-Europe Foundation</b>, held on October 8th, 2025 its quarterly diplomatic & business dialogue in Brussels.  
      </p>
      <p class="mt-5">
        One key message stood out clearly: <b>Artificial Intelligence is not only an industrial revolution — it is a geopolitical one</b>. Africa holds three key advantages in this new era: vast reserves of critical minerals, abundant renewable energy potential, and the world’s youngest and fastest-growing talent base. Together, these assets can make the 21st century the <i>Renaissance of the African continent</i>.
      </p>
      <p class="mt-5">
        As the European Commission unveils its new AI strategy focused on technological sovereignty, this dialogue arrives at a pivotal moment. It highlights how <b>Europe’s quest for innovation and autonomy</b> can align with <b>Africa’s ambition for industrial transformation and digital empowerment</b>.
      </p>
      <p class="mt-5">
        Speakers emphasized that the future of the Africa-Europe relationship must move <b>beyond interdependence toward co-sovereignty</b> — a partnership where Europe gains technological resilience while Africa achieves digital and industrial autonomy.
      </p>
      <p class="mt-5">
        Three major challenges define this shared journey: 
      </p>
      <ol class="mt-2 list-decimal pl-5">
        <li class="mt-1"><b>Strategic Resources:</b> Africa provides the minerals essential for AI and green technologies. Europe brings capital, technology, and ESG standards. Together, they can create a joint “<i>mineral-to-digital</i>” value chain — from African mines to data centres powering AI ecosystems.</li>
        <li class="mt-1"><b>Energy:</b> AI training demands massive energy. Africa, home to 60% of the world’s best solar potential, can become a global hub for low-carbon data centres. European investment and grid technology can help turn this potential into a sustainable digital-energy nexus.</li>
        <li class="mt-1"><b>Talent:</b> With a median age of 19, Africa’s youth represent the largest untapped AI talent pool. Europe faces a shortage of one million data scientists by 2030. Joint investment in education, training, and tech entrepreneurship can bridge this gap.</li>
      </ol>
      <p class="mt-5">
        Financing opportunities abound — from EU and EIB instruments to private and diaspora capital. The real challenge is to channel these funds into <b>bankable projects</b> that drive both stability and productivity. Ultimately, the convergence between Europe’s AI strategy and Africa’s digital ambition lies in their <b>complementary strengths</b>: Africa’s minerals, energy, and youth meet Europe’s capital, technology, and governance.
      </p>
      <p class="mt-5">
        As the world enters a new multipolar era, <b>Europe and Africa must shape their shared future together</b> — as equal partners building the foundations of the AI century.
      </p>
    `,
    agenda: [
      {
        title: "Welcome",
        dateTime: "2025-10-10T09:00:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li><b>Mr. Loïc De Cannière</b>, Advisory Board Member, Brussels-Africa Hub; Founder, Incofin Investment Management; Author, The Future of Employment in Africa</li>
            <li><b>Ms. Ewelina Oblacewicz</b>, Senior Partnerships and Impact Co-ordinator, Africa-Europe Foundation</li>
          </ul>`,
      },
      {
        title: "Setting the Scene",
        dateTime: "2025-10-10T09:10:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li><b><i>AI and Digital Sovereignty: Rebalancing the Africa–Europe Partnership – Key Takeaways from AEF’s Forthcoming Paper</i></b><br/><b>Mr. Youssef Travaly</b>, Senior Advisor, Africa-Europe Foundation</li>
            <li><b><i>A global overview of the Critical Raw Materials Market</i></b><br/><b>Ms. Patricia Bingoto-Maeder</b>, Senior Expert, McKinsey & Company</li>
            <li><b><i>Introduction of the B20 Recommendations</i></b><br/><b>Mr. Gianluca Riccio</b>, Co-Chair, B20 Finance & Infrastructure Taskforce; Chair, Finance Committee, Business at OECD (BIAC)</li>
          </ul>`,
      },
      {
        title: "Session 1: Enabling Africa’s AI Infrastructure – AU–EU Cooperation on Investment and Critical Raw Materials",
        dateTime: "2025-10-10T09:35:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li><b>Mr. Youssef Travaly</b>, Senior Advisor, Africa-Europe Foundation</li>
            <li><b>Mr. Jean Van Wetter</b>, CEO, Enabel, Belgium</li>
            <li><b>Moderated by Ms. Keyzom Ngodup Massally</b>, Director of the AI Hub for Sustainable Development and Head of Digital and AI Programmes, UNDP</li>
          </ul>`,
      },
      {
        title: "Coffee Break",
        dateTime: "2025-10-10T10:05:00+02:00",
      },
      {
        title: "Session 2: Financing Africa’s AI Future – Private Sector Perspectives on Investment and Partnerships",
        dateTime: "2025-10-10T10:20:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li><b>Ms. Phuthi Mahanyele</b>, South Africa Chief Executive Officer and Executive Director of Naspers Limited and Prosus B.V.</li>
            <li><b>Mr. Enrico Bagnasco</b>,  President, Confindustria for Africa & Middle East; CEO at SPARKLE</li>
            <li><b>Mr. Benoit Chervalier</b>,  Investment Banker; President Africa Network Business Europe; Executive Director Business and Industry in Africa Chair, Morocco</li>
            <li><b>Mr. Emmanuel Lubanzadio</b>, Africa Lead, OpenAI</li>
            <li><b>Moderated by Ms. Patricia Bingoto-Maeder</b>, Senior Expert, McKinsey & Company</li>
          </ul>`,
      },
      {
        title: "Concluding Reflections",
        dateTime: "2025-10-10T11:15:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li><b>H.E. Ms. Tokozile Xasa</b>, Ambassador of South Africa to the Kingdom of Belgium and the European Union</li>
            <li><b>H.E. Mr. Johan Swinnen</b>, Belgian Diplomat and Former Ambassador/li>
          </ul>`,
      },
      {
        title: "Way Forward",
        dateTime: "2025-10-10T11:25:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li><b>Mr. Mouctar Bah</b>, Executive Chairman, Brussels-Africa Hub</li>
          </ul>`,
      },
    ],
    photos: ["0572b29a-8527-49f7-9dcb-36d47caaecf2.jpeg","0804f3b8-0d78-4f1f-9f84-7967dfdf3bc9.jpeg","1cb9e5fb-d779-4e83-97e4-ad646c4c50b4.jpeg","1dd1f474-5a3e-4688-a5c3-16a24dac2a9f.jpeg","20903e32-9687-4508-9589-bb179759e1a9.jpeg","289dcd33-4627-4dd5-be4b-c8a8e5c334db.jpeg","35922efc-5676-462b-b4ae-b4242bdbcf27.jpeg","3e90d9ef-f7c3-4246-80d0-c6bbf8b70ea0.jpeg","52191a2f-81ce-4e5f-845c-861573a99286.jpeg","5337c508-6257-4bd7-960c-9fbabd025e25.jpeg","56228d85-5587-4902-b3c1-cfe70a497e17.jpeg","5cf6aa74-a541-4116-b71b-cb4ee3d00f21.jpeg","68cb83c7-d528-4d9f-82f7-5c1efe2e7ebb.jpeg","8229c3d1-2208-46ed-ba4d-3edb37c6811f.jpeg","92244112-fca6-4252-af3a-49da46229efc.jpeg","95b9a8a9-bd0d-4d33-a8c4-874cddacd48d.jpeg","97b9d114-2a1e-4dde-a649-b6b9e6ae8a3d.jpeg","a22e0ac5-1a30-4a49-a9b1-e20e8c3c5468.jpeg","aead8ddb-1a1f-4728-9992-bdea4640b4be.jpeg","b24e3080-63e7-49a7-9dda-8fce2a3a4fbb.jpeg","b9641308-f5c1-4d7b-a9e7-b8b04afaf224.jpeg","bcca7982-86c4-4a64-ad96-cdc34f51e88d.jpeg","c558054b-675f-458f-999f-a8499641e493.jpeg","d1a5ce79-4478-4474-818e-bcef6b3593eb.jpeg","d97ddee6-3426-40d4-a016-b0d83eaff39f.jpeg","e93d92d6-a667-467d-9d5f-4e885e9f0dbf.jpeg","f6635328-e724-4463-b7cb-37f56b1754cc.jpeg","fe8669f1-2d3d-4b90-9124-fe712ab11e62.jpeg","ff139f39-5219-45b7-9d73-e4bbc146f7ca.jpeg"],
    organizers: [
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
      {
        name: 'Africa-Europe Foundation',
        link: 'https://www.africaeuropefoundation.org/',
        logo: process.env.PUBLIC_URL + '/img/partners/africa-europe-foundation.png',
      }
    ],
  },
    {
    id: "j9PA46Sz",
    title: "Diplomatic Breakfast Roundtable",
    dateTime: "2025-06-20",
    location: "Maison de la Poste (Gare Maritime), Rue Picard 7, 1000 Brussels",
    summary: "G20 summit in South Africa - The role of Multilateralism, e.g., Africa - Europe - Türkiye, in Financing and building Catalyst Infrastructure projects in Africa?",
    banner: "Flag_of_Turkey.svg.png",
    description: `
      <p>
        On June 20, 2025, the Brussels-Africa Hub, in partnership with WTS Global, hosted its Quarterly Diplomatic Breakfast Roundtable at Maison de la Poste in Brussels. The event focused on the role of multilateralism—particularly between Africa, Europe, and Türkiye—in financing and developing catalyst infrastructure across Africa, in the context of South Africa’s historic G20 Presidency.
      </p>
      <p class="mt-5">
        High-level speakers, including ambassadors, international organization leaders, and private sector experts, explored key topics such as infrastructure financing, mineral value chains, and EU-Africa investment partnerships. The Brussels-Africa Hub also shared its contributions to the G20's Finance & Infrastructure Task Force.
      </p>
      <p class="mt-5">
        With Africa's population rapidly growing, yet still receiving limited infrastructure investment, the roundtable highlighted the urgent need for stronger global cooperation to drive sustainable development on the continent.
      </p>
    `,
    agenda: [
      {
        title: "Doors open",
        dateTime: "2025-06-20T09:30:00+02:00",
      },
      {
        title: "Welcome and introduction",
        dateTime: "2025-06-20T10:00:00+02:00",
        description: `
          Wim Wuyts, CEO of <a href="https://wts.com/global" target="_blank" rel="noopener noreferrer" class="text-blue-500">WTS Global</a>
        `
      },
      {
        title: "Opening remark: South Africa",
        dateTime: "2025-06-20T10:05:00+02:00",
        description: "H.E. Xasa Tokozile, Ambassador of South Africa to the Kingdom of Belgium and the European Union"
      },
      {
        title: "Opening remark: Türkiye",
        dateTime: "2025-06-20T10:20:00+02:00",
        description: "H.E. Faruk Kaymakcı, Ambassador, Permanent Delegate of the Republic of Türkiye to the European Union"
      },
      {
        title: "How is UNIDO contributing to the development of infrastructure projects in Africa?",
        dateTime: "2025-06-20T10:35:00+02:00",
        description: "H.E. Christophe Yvetot, Representative to the European Union and Directorate of Global Partnerships and External Relations at UNITED NATIONS INDUSTRIAL DEVELOPMENT ORGANIZATION (UNIDO)"
      },
      {
        title: "Zoom-in on the draft policy paper on “Finance & Infrastructure” for the G20 and the role of Brussels-Africa Hub in shaping it?",
        dateTime: "2025-06-20T10:45:00+02:00",
        description: `
          Mr Loïc Cannière, Advisory Board Member at <a href="https://www.brusselsafricahub.eu/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Brussels-Africa Hub</a>
        `
      },
      {
        title: "Infrastructure challenges and opportunities to enable optimal mineral value chains in Africa.",
        dateTime: "2025-06-20T11:00:00+02:00",
        description: `
          Mr Frank Bekaert, Senior Partner at <a href="https://www.mckinsey.com/" target="_blank" rel="noopener noreferrer" class="text-blue-500">McKinsey & Company</a>
        `
      },
      {
        title: "Could an EU-Turkish private sector partnership leads to more capital inflow towards Africa?",
        dateTime: "2025-06-20T11:20:00+02:00",
        description: `
          Ms. Ebru Nur YILDIZ, Project Finance Director at <a href="https://www.limak.com.tr/homepage" target="_blank" rel="noopener noreferrer" class="text-blue-500">Limak Holding</a>
        `
      },
      {
        title: "How could Africa attracts more German & European private Capital?",
        dateTime: "2025-06-20T11:40:00+02:00",
        description: `
          Ms Inken Taubenheim, Director at <a href="https://wts.com/de-en" target="_blank" rel="noopener noreferrer" class="text-blue-500">WTS Global Germany</a>
        `
      },
      {
        title: "How can Cooperation Agencies like GIZ support European investments in Africa?",
        dateTime: "2025-06-20T12:00:00+02:00",
        description: `
          Mr Reinhold Elges, Director at <a href="https://www.giz.de/en/html/index.html" target="_blank" rel="noopener noreferrer" class="text-blue-500">GIZ</a>
        `
      },
      {
        title: "Closing remarks and way forward",
        dateTime: "2025-06-20T12:20:00+02:00",
        description: `
          Mouctar Bah, Executive Chairman of <a href="https://www.brusselsafricahub.eu/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Brussels-Africa Hub</a>
        `
      },
      {
        title: "End",
        dateTime: "2025-06-20T12:30:00+02:00",
        description: null
      },
    ],
    photos: ["0433882c-2f2e-44d5-9973-26248384773a.jpeg","26bff61b-fd16-49d0-a56c-c935ff70c75d.jpeg","3785355b-60e0-48e1-81e7-bde35923e0c6.jpeg","52ecdd20-0ded-4f81-a5f5-76eb53a855f8.jpeg","555b6a94-a4a9-46bc-a95f-ea849456c032.jpeg","5944e5cb-e6f0-419a-b000-9b781054a74c.jpeg","77e79ac6-00da-4cae-96d5-a92fe906d142.jpeg","7bc72dc3-e1cb-4e41-8a5b-f16ed76705a5.jpeg","d05f543f-d62c-49a3-b8e3-5d154ba7e4b3.jpeg","da486034-0a9b-4c34-bd83-c055d75c1562.jpeg","f0e9209d-283e-4942-bb84-f1a63730fd36.jpeg"],
    organizers: [
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
    ],
    sponsors: [
      {
        name: "WTS Global",
        link: "https://wts.com/global",
        logo: process.env.PUBLIC_URL + "/img/partners/wts-global.jpeg",
      },
    ],
  },
  {
    id: "feQvc98Q",
    title: "Diplomatic Breakfast Roundtable - Trade & Investment and tariffs in the context of the G20 summit in South Africa",
    dateTime: "2025-04-11",
    location: "Maison de la Poste (Gare Maritime), Rue Picard 7, 1000 Brussels",
    summary: "This year, we are proud to dedicate our quarterly gatherings to the historic G20 Presidency of South Africa, marking the first-ever G20 Summit on African soil",
    banner: "G20.png",
    description: `
      <p>
        This year, we are proud to dedicate our quarterly gatherings to the historic <b>G20 Presidency of South Africa</b>, marking the first-ever G20 Summit on African soil. In the context of ongoing global trade disturbances, including tariffs and other hidden barriers, our inaugural diplomatic breakfast will focus on the G20 theme of Trade and Investment, with a special emphasis on the impact of tariffs on business between Europe and Africa.
      </p>
    `,
    agenda: [
      {
        title: "Doors open - Arrival and registration",
        dateTime: "2025-04-11T09:30:00+02:00",
      },
      {
        title: "Welcome and introduction",
        dateTime: "2025-04-11T10:00:00+02:00",
        description: `
          Wim Wuyts, CEO of <a href="https://wts.com/global" target="_blank" rel="noopener noreferrer" class="text-blue-500">WTS Global</a>
        `
      },
      {
        title: "Opening remarks",
        dateTime: "2025-04-11T10:05:00+02:00",
        description: "H.E. Xasa Tokozile, Ambassador of South Africa to the Kingdom of Belgium and the European Union"
      },
      {
        title: "What could be the impact of prospective tariffs on global trade?",
        dateTime: "2025-04-11T10:20:00+02:00",
        description: `
          Wim Wuyts, CEO of <a href="https://wts.com/global" target="_blank" rel="noopener noreferrer" class="text-blue-500">WTS Global</a>
        `
      },
      {
        title: "What does the private sector community like VOKA expect from the G20 summit in South Africa?",
        dateTime: "2025-04-11T10:40:00+02:00",
        description: `
          Hendrik Caluwé, Senior Adviser International Trade at <a href="https://www.voka.be/" target="_blank" rel="noopener noreferrer" class="text-blue-500">VOKA</a>
        `
      },
      {
        title: "What is the role of Development Agencies in fostering global trade & investment in these turbulent times?",
        dateTime: "2025-04-11T11:10:00+02:00",
        description: `
          Jean Van Wetter, CEO at <a href="https://www.enabel.be/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Enabel</a>
        `
      },
      {
        title: "Q&A",
        dateTime: "2025-04-11T11:30:00+02:00",
        description: null
      },
      {
        title: "Closing remarks and way forward",
        dateTime: "2025-04-11T11:55:00+02:00",
        description: `
          Mouctar Bah, Executive Chairman of <a href="https://www.brusselsafricahub.eu/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Brussels-Africa Hub</a>
        `
      },
      {
        title: "End",
        dateTime: "2025-04-11T12:00:00+02:00",
        description: null
      },
    ],
    photos: ["0c61046f-c551-4956-8f62-64bb1040c710.jpeg","0d54257a-95c3-4726-88b0-5fdb0cdde54c.jpeg","3969badd-4ba0-4311-b11b-c46eecfdac25.jpeg","4ba3b38d-987a-4691-bf25-6b1e69a9ef83.jpeg","7c204ee2-e349-4f55-ad67-4d8f02018870.jpeg","87972be0-e4fe-4d52-a181-c8fcdedad60b.jpeg","9671901f-5418-4623-9002-16942a3d2273.jpeg"],
    organizers: [
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
    ],
    sponsors: [
      {
        name: "WTS Global",
        link: "https://wts.com/global",
        logo: process.env.PUBLIC_URL + "/img/partners/wts-global.jpeg",
      },
    ],
  },
  {
    id: "tWDV0pod",
    title: "IPO Business Game",
    dateTime: "2025-03-12",
    location: "Euronext, Brussels",
    summary: "An invaluable opportunity for students to deepen their understanding of capital markets and explore the unique potential of African stock.",
    banner: "euronext.png",
    description: `
      <p>
        The IPO Business Game is an immersive event designed to provide students with a hands-on learning experience in capital markets, with a special focus on African stock exchanges. Hosted at Euronext Brussels, this initiative is a collaboration between Brussels-Africa Hub, Euronext Brussels, the Solvay Finance Club, and the Madiba Club.
      </p>
      <p class="mt-5">
        Participants have the unique opportunity to engage with leading finance professionals and industry experts who provide valuable insights into the IPO process, equity markets, and the role of African financial institutions in the global economy. The event also features an interactive business game where students put their knowledge into practice by developing and pitching equity stories to a distinguished jury.
      </p>
      <p class="mt-5">
        Key elements of the event include:
      </p>
      <ul class="mt-2 list-disc pl-5">
        <li>
          <b>Expert Insights:</b> Presentations and discussions led by finance professionals, including:
          <ul class="mt-0 list-disc pl-5">
            <li><b>Paulina Willak</b> (Degroof Petercam)</li>
            <li><b>Ouissem Barbouchi</b> (OBAFRICA)</li>
            <li><b>Fabrice do Rego</b> (Blueprint VC)</li>
            <li><b>Jean-Julien Ilunga, CFA</b> (Brussels-Africa Hub)</li>
          </ul>
        </li>
        <li class="mt-1"><b>IPO Business Game:</b> A competitive simulation where students analyze market conditions, craft IPO strategies, and present their cases to a panel of judges.</li>
      </ul>
    `,
    photos: ["410418bc-113f-4445-82c2-46cb2d6f3311.jpeg","79eb05c4-52d8-4563-8655-63692715f77d.jpeg","8089870f-d3b2-4170-a3e4-a2b6ea01a326.jpeg","ba507073-0415-4491-856c-59cbc71765ad.jpeg","cf15f0ac-f30d-4fa4-98ce-bf99796f01c5.jpeg","de4a4a61-1c30-4b5d-8bc1-3e1fedfb5cb3.jpeg"],
    organizers: [
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
      {
        name: "Euronext Brussels",
        link: "https://www.euronext.com/en/markets/brussels",
        logo: process.env.PUBLIC_URL + "/img/partners/euronext.png",
      },
      {
        name: "Madiba Club",
        link: "https://madibaclub.com/",
        logo: process.env.PUBLIC_URL + "/img/partners/madiba-club.png",
      },
      {
        name: "Solvay Finance Club",
        link: "https://www.solvayfinanceclub.eu/",
        logo: process.env.PUBLIC_URL + "/img/partners/solvay-finance-club.avif",
      },
    ],
  },
  {
    id: "weGulxVb",
    title: "Walking dinner session on South Africa's G20 Presidency",
    dateTime: "2024-12-18",
    location: "The Merode, Brussels",
    summary: "In the context of the South African Presidency of the G20 in 2025, the Brussels-Africa Hub in collaboration with the South African Embassy in Brussels, held an exclusive walking dinner.",
    banner: "Flag_of_South_Africa.svg.png",
    description: `
      <p>
        South Africa will be the fourth country of the Global South to host the G20 Summit in 2025, in succession, on the work done by Indonesia (2022), India (2023), Brazil (2024).
      </p>
      <p class="mt-5">
        In the context of the South African Presidency of the G20 in 2025, the Brussels-Africa Hub in collaboration with the South African Embassy in Brussels, held an exclusive walking dinner on December 18, 2024 in Brussels, in which H.E. Maud Vuyelwa Dlomo, South Africa's Deputy Director-General for the Department of International Relations and Cooperation, gave an exclusive insight into their G20 Presidency agenda, in line with the African Union's Agenda 2063 on Africa's development, as pertains climate change, energy, food security, and debt challenges that impact Africa and the development agenda of the Global South, including advancing infrastructure development and global governance reform.
      </p>
      <p class="mt-5">
        The Brussels-Africa Hub, an international non-profit organization focused on fostering the free movement of capital between Europe and Africa, and the South African Embassy in Brussels joined forces to make this gathering another successful one.
      </p>
    `,
    photos: ["011c663b-f027-4ea7-bbd8-96c028d8c437.jpg","0b2498e2-cd6a-4489-ba57-85e5d0089ec6.jpg","0b432b63-efeb-472f-8c2a-63fa23b99b48.jpg","12260138-4931-4dcf-8652-e69a077da2bd.jpg","161bddc4-7143-42c3-a488-03cfc545d55d.jpg","236b5897-e53e-4dd7-b565-51900a35e2a1.jpg","34556696-68c4-4fcc-9fa9-acc1ba23cb2f.jpg","371988b7-bfba-400b-b224-c907a4b8ed35.jpg","3cfa4fee-7464-46ce-9d99-555d23ad9330.jpg","4ae4ea6f-8b62-4228-b12e-8650c07b4315.jpg","4c06972b-e2b1-4d3c-9d57-c0238ff7b249.jpg","5040c278-22ac-4e71-8185-f437eed45ba1.jpg","526bf735-286b-40f7-b5eb-7a3334382e6e.jpg","5a06e01a-c478-4ee1-84e3-8eec2d5eca2d.jpg","72b5fe67-e77f-43de-ad33-3df5fccce7eb.jpg","7983fd4e-275b-471c-8b37-69814bc13749.jpg","84b7c670-bf6b-4e81-bc2a-cc73f8198feb.jpg","861fff13-24d2-4d07-8659-d9f619927a81.jpg","94fa6b63-bb85-44d0-87d8-9dbda8eb1bcc.jpg","a0ff6401-987a-4d32-8b59-d35c7b1df1fe.jpg","a11161ed-8cf8-437e-b900-1994a4afb2bf.jpg","a36f62d3-a4bb-46ec-b56c-82146fb1ee50.jpg","a7da72db-2aa4-44c6-a0f5-44a95227e9d3.jpg","c00e0b38-14cb-4486-a9ca-8bcfc7461366.jpg","c13534f2-3dd0-43c5-a958-b93bca63c83c.jpg","c4326ea5-1bd2-4546-b4ef-eedca2795fd9.jpg","c896c2b7-d349-4af9-b8ea-7a169a7e52d2.jpg","d1afb6e0-dc56-42a0-b5f9-0b6b8f87a851.jpg","dbca674c-1de3-494a-bfef-68055f6d12f2.jpg","e7031f18-6d32-4040-964f-08536b3616a2.jpg","ebda1b49-f4c5-4b9b-af49-e0657e3fc43a.jpg","f40a484a-1419-45ed-86ac-ff1b797319df.jpg","f90b0f2b-7d7b-455f-88a1-eed7073c9d2d.jpg"],
    organizers: [
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
      {
        name: "Embassy of the Republic of South Africa",
        link: "http://www.southafrica.be/",
        logo: process.env.PUBLIC_URL + "/img/partners/embassy-of-the-republic-of-south-africa.jpeg",
      },
    ],
    sponsors: [
    ],
  },
  {
    id: "RndmgeZO",
    title: "Diplomatic Breakfast Roundtable - The Value Chain of Green Hydrogen in Africa",
    dateTime: "2024-12-06",
    location: "Maison de la Poste (Gare Maritime), Rue Picard 7, 1000 Brussels",
    summary: "The Brussels-Africa Hub's fourth Diplomatic Roundtable Discussion, on the Value Chain of Green Hydrogen in Africa.",
    banner: "Flag_of_Morocco.svg.png",
    description: `
      <p><b>Green hydrogen</b> represents <b>a significant opportunity</b> for Africa, especially given the continent's vast renewable energy resources. With abundant solar, wind, and hydropower potential, Africa can become a global hub for the production of green hydrogen—hydrogen produced using renewable energy sources. This aligns with global efforts to decarbonize industries and transition towards cleaner energy systems. Europe, seeking to diversify its clean energy imports and meet ambitious climate goals, views Africa as a strategic partner in the production and supply of green hydrogen. The EU's <b>Global Gateway initiative</b>, of which the <b>Brussels-Africa Hub</b> is member of the <b>EU Dialogue Platform</b>, aims to foster sustainable and inclusive growth in partner countries. This offers a <b>vital platform for collaboration between Africa and Europe on green hydrogen</b>.</p>
      <h3 class="mt-5 font-bold">Context</h3>
      <p class="mt-5">The <b>value chain of green hydrogen in Africa</b> covers a spectrum of activities, from renewable energy production to the consumption of hydrogen in industrial processes. It can be broken down into the following key stages:</p>
      <ul class="mt-2 list-disc pl-5">
        <li><b>Renewable Energy Generation:</b> Africa's rich solar and wind resources can power electrolysis plants to produce green hydrogen. Investments in infrastructure, particularly in wind and solar power plants, are essential to ensure the availability of the required electricity to produce green hydrogen.</li>
        <li><b>Hydrogen Production and Electrolysis:</b> Green hydrogen is produced by using renewable electricity to split water into hydrogen and oxygen through electrolysis. Africa, particularly countries like Morocco, is ideal for the deployment of large-scale electrolysis units due to the abundance of renewable energy sources.</li>
        <li><b>Storage and Transportation:</b> Once produced, hydrogen must be stored and transported. This requires investment in storage technologies (such as liquid hydrogen or ammonia) and the development of pipelines, storage terminals, and export infrastructure. Efficient transportation systems are key for exporting green hydrogen to Europe and other global markets.</li>
        <li><b>Hydrogen Conversion to Derivatives:</b> Hydrogen can be converted into ammonia, methanol, or other derivatives, which are easier to transport. These derivatives have applications in agriculture, shipping, and the chemical industry, making them valuable exports for African economies.</li>
        <li><b>End Use Applications:</b> Hydrogen and its derivatives can be used in various sectors, including heavy industries, transportation, and power generation. In Africa, these products could fuel domestic industries, further adding value to the local economy while also positioning the continent as a green energy exporter.</li>
      </ul>
      <h3 class="mt-5 font-bold">Morocco</h3>
      <p class="mt-5">In March 2024, Morocco unveiled the "<a href="https://www.cliffordchance.com/content/dam/cliffordchance/briefings/2024/04/focus-on-hydrogen-navigating-moroccos-new-policy.pdf" target="_blank" rel="noopener noreferrer" class="text-blue-500"><b>Offre Maroc</b></a>" a comprehensive framework that marks a pivotal moment for its green hydrogen sector. This initiative represents a strategic approach to building a full-fledged <b>green hydrogen ecosystem in Morocco</b>, focusing on both horizontal and vertical development across the value chain.</p>
      <h3 class="mt-5 font-bold">Objectives</h3>
      <p class="mt-5">The EU Global Gateway initiative seeks to promote sustainable infrastructure and digitalization in partner countries, creating a framework for cooperation between Europe and Africa on green hydrogen. This collaboration can take several forms:</p>
      <ul class="mt-2 list-disc pl-5">
        <li><b>Co-financing of Green Hydrogen Projects:</b> The EU, through the Global Gateway, can provide financial support for green hydrogen infrastructure projects in Africa, including renewable energy production, electrolysis, and export infrastructure. This financing can be complemented by investments from European private sector players who are eager to secure green hydrogen supply chains.</li>
        <li><b>Technology Transfer and Capacity Building:</b> Europe can collaborate with African countries like Morocco to transfer technology and share expertise in green hydrogen production and storage. By enhancing local capabilities, this partnership can help build a skilled workforce and accelerate Africa's green hydrogen transition.</li>
        <li><b>Market Integration and Trade:</b> The development of green hydrogen markets between Europe and Africa can be facilitated through regulatory alignment and the creation of new trade agreements. Such agreements would ensure smooth cross-border hydrogen flows, benefiting both regions economically.</li>
        <li><b>Infrastructure Development:</b> The EU can support the development of critical infrastructure such as hydrogen pipelines, storage facilities, and shipping terminals. Joint investments in such infrastructure can ensure that Africa’s green hydrogen reaches European markets efficiently.</li>
        <li><b>Research and Innovation Partnerships:</b> Europe and Africa can collaborate on research initiatives focused on improving electrolysis technologies, hydrogen storage methods, and the production of hydrogen derivatives. Joint R&D efforts would help reduce costs and increase the efficiency of hydrogen production.</li>
      </ul>
      <h3 class="mt-5 font-bold">Participants</h3>
      <p class="mt-5">The roundtable will gather a diverse group of participants, including:</p>
      <ul class="mt-0 list-disc pl-5">
        <li>Diplomatic representatives from European and African countries;</li>
        <li>Industry leaders from the mining, energy, and logistics sectors;</li>
        <li>Institutional and private investors;</li>
        <li>Experts from international organizations;</li>
        <li>Development agencies;</li>
        <li>Academics;</li>
      </ul>
      <h3 class="mt-5 font-bold">Conclusion</h3>
      <p class="mt-5">The development of the green hydrogen value chain in Africa presents a unique opportunity for both African nations and Europe. Africa, with its vast renewable energy potential, can become a major producer of green hydrogen, while Europe, through the Global Gateway initiative, can help drive the necessary investment, technology transfer, and infrastructure development. Morocco's <b>"Offre Maroc"</b> framework is a significant step forward in realizing this potential and serves as a model for other African nations. <b>A strategic partnership between Europe and Africa on green hydrogen can drive sustainable economic growth, create jobs, and contribute to the global energy transition.</b></p>
      <p class="mt-5">If you wish to be added to our distribution list, feel free to subscribe <a href="http://eepurl.com/c-4RcT" target="_blank" rel="noopener noreferrer" class="text-blue-500">here</a>.</p>
    `,
    agenda: [
      {
        title: "Doors open",
        dateTime: "2024-12-06T09:30:00+01:00",
      },
      {
        title: "Welcome and introductions",
        dateTime: "2024-12-06T10:00:00+01:00",
        description: `
          Wim Wuyts, CEO of <a href="https://wts.com/global" target="_blank" rel="noopener noreferrer" class="text-blue-500">WTS Global</a>
        `
      },
      {
        title: "Opening remarks",
        dateTime: "2024-12-06T10:05:00+01:00",
        description: "H.E. Mohammed Ameur, Ambassador of Morocco to the Kingdom of Belgium"
      },
      {
        title: "Keynote: a global overview of the Green Hydrogen dynamic, focus Africa",
        dateTime: "2024-12-06T10:20:00+01:00",
        description: `
          Frank Bekaert, Senior Partner at <a href="https://www.mckinsey.com/" target="_blank" rel="noopener noreferrer" class="text-blue-500">McKinsey & Company</a>
        `
      },
      {
        title: "What does it take to build the required trans-Mediterranean infrastructure",
        dateTime: "2024-12-06T10:40:00+01:00",
        description: `
          Kristof Waterschoot, Managing Director at <a href="https://www.portofantwerpbruges.com/en/our-port" target="_blank" rel="noopener noreferrer" class="text-blue-500">Port of Antwerp-Bruges</a><br/>
          Arno Büx, CCO at <a href="https://www.fluxys.com/en#/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Fluxys</a>
        `
      },
      {
        title: "“Offre Maroc”: What does it mean for European Investors",
        dateTime: "2024-12-06T11:25:00+01:00",
        description: `
          Julie Godin, Manager - European Partnerships at <a href="https://gggi.org/about/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Global Green Growth Institute</a><br/>
          Mustapha Mourahib, Partner at <a href="https://www.cliffordchance.com/content/dam/cliffordchance/briefings/2024/04/focus-on-hydrogen-navigating-moroccos-new-policy.pdf" target="_blank" rel="noopener noreferrer" class="text-blue-500">Clifford Chance</a>
        `
      },
      {
        title: "Closing remarks and way forward",
        dateTime: "2024-12-06T11:55:00+01:00",
        description: `
          Mouctar Bah, Executive Chairman of <a href="https://www.brusselsafricahub.eu/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Brussels-Africa Hub</a>
        `
      },
      {
        title: "End",
        dateTime: "2024-12-06T12:00:00+01:00",
        description: null
      },
    ],
    photos: ["1b64a328-77b5-4d94-9985-1b91e5cd01a3.jpeg","30605870-bc91-401e-b993-c582f484fd6d.jpeg","5377af39-6c7f-4f05-940b-378389196369.jpg","73f77e6c-7f2e-45c5-b913-ec5645012d56.jpeg","787df395-9c3f-4715-a446-3581eb29e81b.jpeg","fc3146d7-4050-48a9-abde-faa9aafa1f4f.jpeg"],
    organizers: [
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
    ],
    sponsors: [
      {
        name: "WTS Global",
        link: "https://wts.com/global",
        logo: process.env.PUBLIC_URL + "/img/partners/wts-global.jpeg",
      },
    ],
  },
  {
    id: "WuC6MjVe",
    title: "Diplomatic Breakfast Roundtable - Localising the value chain of strategic and critical minerals in Africa",
    dateTime: "2024-09-06",
    location: "Maison de la Poste (Gare Maritime), Rue Picard 7, 1000 Brussels",
    summary: "The Brussels-Africa Hub's third Diplomatic Roundtable Discussion, in close collaboration with the Embassy of the Republic of the Democratic Republic of Congo in Brussels.",
    banner: "Flag_of_the_Democratic_Republic_of_the_Congo.svg.png",
    description: `
      <p>The strategic minerals sector offers significant opportunities for Europe and Africa to build win-win partnerships, particularly in developing local value chains.</p>
      <p class="mt-5">The materials industry, now valued at approximately $8 trillion, has grown by 6% annually since 2000. While lithium and nickel supplies have surged, copper production lags behind. By 2035, demand is expected to soar for lithium (+480%), nickel (+60%), and copper (+30%). This demand shift, driven by anticipated supply shortages, not only highlights Africa's need for expanded mining and processing capabilities, but also raises many fundamental questions.</p>
      <ul class="mt-0 list-disc pl-5">
        <li>How can local African SMEs benefit?</li>
        <li>What investment opportunities exist in subcontracting and the circular economy?</li>
        <li>How can ESG risks and traceability be managed?</li>
        <li>What role should development finance institutions play?</li>
      </ul>
      <p class="mt-5">These topics were central to discussions with African ambassadors and diplomats at our recent roundtable. Insights from experts like Frank Bekaert (<a href="https://www.mckinsey.com/" target="_blank" rel="noopener noreferrer" class="text-blue-500">McKinsey</a>), <a href="https://www.linkedin.com/in/joristotte/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Joris Totté</a> (<a href="https://www.bio-invest.be/" target="_blank" rel="noopener noreferrer" class="text-blue-500">BIO</a>) and <a href="https://www.linkedin.com/in/jean-van-wetter-a5a574/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Jean Van Wetter</a> (<a href="https://www.enabel.be/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Enabel</a>) emphasized three critical factors for sustainable industry growth: value chain partnerships, cost efficiency, and enabling policies.</p>
      <p class="mt-5">The event, held in collaboration with the embassy of the Democratic Republic of Congo, set the stage for further discussions at the Makutano Forum in Kinshasa (13-15 November 2024).</p>
      <p class="mt-5">If you wish to be added to our distribution list, feel free to subscribe <a href="http://eepurl.com/c-4RcT" target="_blank" rel="noopener noreferrer" class="text-blue-500">here</a>.</p>
    `,
    agenda: [
      {
        title: "Doors open",
        dateTime: "2024-09-06T09:30:00+02:00",
      },
      {
        title: "Welcome and introductions",
        dateTime: "2024-09-06T10:00:00+02:00",
        description: `
          <a href="https://www.linkedin.com/in/wim-wuyts-1a30455/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Wim Wuyts</a>, CEO of <a href="https://wts.com/global" target="_blank" rel="noopener noreferrer" class="text-blue-500">WTS</a>
        `
      },
      {
        title: "Opening remarks",
        dateTime: "2024-09-06T10:05:00+02:00",
        description: "H.E. Christian Ndongala Nkuku, DRC Ambassador to the Kingdom of Belgium and the EU"
      },
      {
        title: "An overview of the global dynamic in the strategic and critical minerals sector",
        dateTime: "2024-09-06T10:20:00+02:00",
        description: `
          Frank Bekaert, Senior Partner at <a href="https://www.mckinsey.com/" target="_blank" rel="noopener noreferrer" class="text-blue-500">McKinsey & Company</a>
        `
      },
      {
        title: "How to finance the value chain localization",
        dateTime: "2024-09-06T10:40:00+02:00",
        description: `
          <a href="https://www.linkedin.com/in/joristotte/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Joris Totté</a>, CEO of <a href="https://www.bio-invest.be/" target="_blank" rel="noopener noreferrer" class="text-blue-500">BIO Invest</a>
        `
      },
      {
        title: "How to enhance the required managerial and technical skills",
        dateTime: "2024-09-06T11:15:00+02:00",
        description: `
          <a href="https://www.linkedin.com/in/jean-van-wetter-a5a574/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Jean Van Wetter</a>, CEO of <a href="https://www.enabel.be/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Enabel</a>
        `
      },
      {
        title: "Roundtable discussions",
        dateTime: "2024-09-06T11:45:00+02:00",
        description: "Facilitated by a Brussels-Africa Hub member"
      },
      {
        title: "Closing remarks and way forward",
        dateTime: "2024-09-06T12:25:00+02:00",
        description: `
          <a href="https://www.linkedin.com/in/mouctar-bah-48a8a425/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Mouctar Bah</a>, Executive Chairman of <a href="https://www.brusselsafricahub.eu/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Brussels-Africa Hub</a>
        `
      },
      {
        title: "End",
        dateTime: "2024-09-06T12:30:00+02:00",
        description: null
      },
    ],
    photos: ["20809157-8efd-4cac-be31-1126fa20c9fe.jpeg","20bc784d-b8cc-4133-88f9-6662b5104a6e.jpeg","37a2b54d-e161-4411-a5ea-af8259976fcc.jpeg","3abfb37f-5deb-4660-b3fc-e2a89f1338cc.jpeg","4cbd8e5b-dcbc-4ad2-a00f-2d80df404eb8.jpeg","58c933eb-5bce-4ec6-a44c-bce6dbfa2599.jpeg","61b7cb0d-a694-4b7e-b9f6-52d503e7fc52.jpeg","7efc87ef-09c4-4404-9989-087cea5a6c05.jpeg","8ad82c40-78e7-429f-b71b-bb60693d0a66.jpeg","a2287ad3-e099-41a0-9028-0588db79d614.jpeg","a84c17f0-9913-48b3-b09d-64c04a3e597c.jpeg","cfca19a2-8999-466f-bbfb-2a536b9e0948.jpeg","e1a931c3-7694-4332-9679-9eb74673d56e.jpeg","e63270ee-dcd8-42c9-bcf1-90673cb43d41.jpeg","e7591398-ce67-4560-9f2e-1698b112b888.jpeg","f3322c13-e806-4191-a9b6-13fe4a615628.jpeg"],
    organizers: [
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
    ],
    sponsors: [
      {
        name: "WTS Global",
        link: "https://wts.com/global",
        logo: process.env.PUBLIC_URL + "/img/partners/wts-global.jpeg",
      },
    ],
  },
  {
    id: "vdxmkzHy",
    title: "Diplomatic Breakfast Roundtable - Boosting Africa-Europe value chains: is the Global Gateway fit for purpose?",
    dateTime: "2024-06-07",
    location: "Maison de la Poste (Gare Maritime), Rue Picard 7, 1000 Brussels",
    summary: "On June 7th, the Brussels-Africa Hub hosted its second Diplomatic Roundtable Discussion in close collaboration with the Embassy of the Republic of Kenya in Brussels.",
    banner: "Flag_of_Kenya.svg.png",
    description: `
      <p>On June 7th, the Brussels-Africa Hub hosted its second Diplomatic Roundtable Discussion in close collaboration with the Embassy of the Republic of Kenya in Brussels.</p>
      <p class="mt-5">This exclusive event aimed to facilitate dialogue among African diplomats, EU and Team Europe institutions, and private sector organizations on the implementation of the Global Gateway Africa-Europe Investment Package.</p>
      <p class="mt-5">H.E. Bitange Ndemo, the Ambassador of Kenya to Belgium and the EU, delivered inspiring opening remarks, emphasizing the need to prioritize African interests in the Global Gateway's implementation. Following his speech, Ms Geneviève-Anne Dehoux (European Commission) and Mr Yohann Chaigneau (European Investment Bank) provided insights into the current state of European investment into strategic infrastructure across the African continent. The ensuing discussions focused on "Boosting Africa-Europe value chains" and were expertly led by Holy Ranaivozanany, Deputy Executive Director of the Africa-Europe Foundation.</p>
      <p class="mt-5">As a member of the Global Gateway Dialogue Platform, the Brussels-Africa Hub remains committed to mobilizing the European and African financial ecosystems for a sustainable and effective of the Africa-EU Partnership.</p>
      <p class="mt-5">If you wish to be added to our distribution list, feel free to subscribe <a href="http://eepurl.com/c-4RcT" target="_blank" rel="noopener noreferrer" class="text-blue-500">here</a>.</p>
    `,
    agenda: [
      {
        title: "Doors open",
        dateTime: "2024-06-07T09:30:00+02:00",
      },
      {
        title: "Welcome and introductions",
        dateTime: "2024-06-07T10:00:00+02:00",
        description: "Wim Wuyts, CEO of WTS"
      },
      {
        title: "Opening remarks",
        dateTime: "2024-06-07T10:05:00+02:00",
        description: "H.E. Bitange Ndemo, Kenya's Ambassador to the Kingdom of Belgium and the EU"
      },
      {
        title: "New partnerships to accelerate investments",
        dateTime: "2024-06-07T10:15:00+02:00",
        description: "Senior representative of the European Investment Bank"
      },
      {
        title: "Current status of the Global Gateway implementation",
        dateTime: "2024-06-07T10:25:00+02:00",
        description: "Holy Ranaivozanany, Deputy Executive Director, Africa-Europe Foundation"
      },
      {
        title: "Private sector perspective",
        dateTime: "2024-06-07T10:35:00+02:00",
        description: "A member of Global Gateway Business Advisory Group"
      },
      {
        title: "Roundtable discussions",
        dateTime: "2024-06-07T10:45:00+02:00",
        description: "Facilitated by a Brussels-Africa Hub member"
      },
      {
        title: "Closing remarks and way forward",
        dateTime: "2024-06-07T11:45:00+02:00",
        description: "Mouctar Bah, Executive Chairman of  Brussels-Africa Hub"
      },
      {
        title: "End",
        dateTime: "2024-06-07T12:00:00+02:00",
      },
    ],
    photos: ["133a04cb-a83d-41a6-a121-ccbddece974e.jpeg","23e7ad3b-c522-4aa5-82e6-528b80e10b63.jpeg","4f9d24d5-c875-411e-80a0-3931c3c85d5a.jpeg","95d57143-cef4-4d9b-a2f1-c9c2e0a94156.jpeg","9c7e990a-fbe6-4776-83f9-04a5b3e5a1a2.jpeg","f27f7eaf-d58a-49ed-adfe-c94295aaab4b.jpeg","f3bb0a24-f831-4b7b-a918-24aa4c487dfc.jpeg"],
    organizers: [
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
    ],
    sponsors: [
      {
        name: "WTS Global",
        link: "https://wts.com/global",
        logo: process.env.PUBLIC_URL + "/img/partners/wts-global.jpeg",
      },
    ],
  },
  {
    id: "o27jXq5i",
    title: "Impactful Investments & Opportunities - Europe & Africa",
    dateTime: "2024-03-14",
    location: "Arendt house, Luxembourg",
    summary: "Bringing together various European players to share experience, discuss initiatives and opportunities in the African markets.",
    banner: "banner.jpg",
    description: `
      <p>
        Arendt in partnership with LuxAfrica and Brussels Africa Hub, wish to bring together various European players to share experience, discuss initiatives and opportunities in the African markets. The aim is also to promote the existing ecosystem and create new synergies to facilitate sustainable investments in Africa.
      </p>
      <p class="mt-5">
        This conference targets all actors in the financial sector who have an interest in investment opportunities on the African continent or wish to learn about public/private partnerships or share experience and know-how.
      </p>
    `,
    agenda: [
      {
        title: "Registration",
        dateTime: "2024-03-14T14:00:00+01:00",
      },
      {
        title: "Welcome speech",
        dateTime: "2024-03-14T14:30:00+01:00",
      },
      {
        title: "Keynote speech",
        dateTime: "2024-03-14T14:40:00+01:00",
        description: `
          <b>Major trends and overview of geopolitics and geo-economics of Africa</b><br/>
          Incofin Investment Management - Loïc de Cannière
        `
      },
      {
        title: "Panel 1",
        dateTime: "2024-03-14T15:10:00+01:00",
        description: `
          <b>EU, Luxembourg and Belgium initiatives for mobilising impactful investments in Africa</b><br/>
          Moderator: Brussels Africa Hub - Guillaume Grange<br/>
          Panelists:<br/>
          <ul class="list-disc pl-5">
            <li class="mt-2">European Investment Bank - Charlotte Julie Rault</li>
            <li class="mt-2">Ministère des affaires étrangères et européennes, de la défense, de la coopération et du commerce extérieur - Paul Weber</li>
            <li class="mt-2">Belgian Development Agency - Jean Van Wetter</li>
          </ul>
        `
      },
      {
        title: "Break",
        dateTime: "2024-03-14T16:00:00+01:00",
      },
      {
        title: "Panel 2",
        dateTime: "2024-03-14T16:30:00+01:00",
        description: `
          <b>Success stories with a focus on Africa</b><br/>
          Moderator: BrussLuxAfrica - Bertrand Moupfouma<br/>
          Panelists:<br/>
          <ul class="list-disc pl-5">
            <li class="mt-2">The Africa Agriculture Investment Fund and its technical assistance (Luxembourg) - Doris Köhn</li>
            <li class="mt-2">Incofin Investment Management - Loïc de Cannière</li>
            <li class="mt-2">Luxembourg House of Financial Technology (LhoFT) - Alex Panican</li>
          </ul>
        `
      },
      {
        title: "Closing remarks",
        dateTime: "2024-03-14T17:30:00+01:00",
      },
      {
        title: "Networking cocktail",
        dateTime: "2024-03-14T17:40:00+01:00",
      },
    ],
    photos: ["1156d527-ec6e-443a-9455-c595f6b8500e.jpeg","2fe1090e-f83b-4225-85e4-a785e9857670.jpeg","39906afa-88c8-441a-8a27-22ba72118f40.jpeg","3c5a2fdb-7fd2-4615-8f89-bd7ee1f6598c.jpeg","4efcda1b-9f82-4390-9f88-8dae9aebd8ee.jpeg","60e37315-24a3-46f0-abef-bad68908de36.jpeg","6774cf59-9794-46a1-8a8d-bb401e73810e.jpeg","6ae3bde0-8b9b-4285-8acb-b31e0ed00144.jpeg","874c90f2-e35c-4d41-80a3-e54f7dd0e88b.jpeg","d7d24655-3d01-4ad4-a87f-daa172d37fc2.jpeg"],
    organizers: [
      {
        name: 'Arendt',
        link: 'https://www.arendt.com/',
        logo: process.env.PUBLIC_URL + '/img/partners/arendt-blue.png',
      },
      {
        name: 'LuxAfrica',
        link: 'https://luxafrica.lu/',
        logo: process.env.PUBLIC_URL + '/img/partners/luxafrica.png',
      },
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
    ],
  },
  {
    id: "TkQHKyWh",
    title: "Diplomatic Breakfast Roundtable - SADC",
    dateTime: "2024-03-08",
    location: "Tour & Taxis",
    summary: "On March 8th the Brussels-Africa Hub officially launched its quarterly Diplomatic Breakfast Roundtable.",
    banner: "Flag_of_South_Africa.svg.png",
    description: `
      <p>
        On March 8<sup>th</sup>, the Brussels-Africa Hub held its inaugural Diplomatic Breakfast Roundtable, a quarterly event aimed at fostering collaboration and dialogue with African ambassadors in Brussels. The focus of this gathering was the Global Gateway Africa-Europe Investment Package which aims to boost smart, clean and secure links in digital, energy and transport sectors and to strengthen health, education and research systems in Africa.
      </p>
      <p class="mt-5">
        WTS Global, a member of the Brussels-Africa Hub, hosted the roundtable, which brought together ambassadors from various countries in the Southern African Development Community (SADC). This regional approach provided a valuable opportunity to engage with diplomats, representatives from EU institutions, the Belgian development agency, and the private sector. The discussions centered around the multifaceted implementation of the Global Gateway initiative, whereby the EU plans to invest around €150B in infrastructure in Africa by 2027, and its potential implications for the EU-SADC Economic Partnership Agreement.
      </p>
      <p class="mt-5">
        In her opening remarks, Her Excellency Mme Tokozile Xasa, the South Africa Ambassador, emphasized the significance of understanding the goals of the Global Gateway from an African perspective. She also stressed the importance of unity and strategy.
      </p>
      <p class="mt-5">
        Mouctar Bah, the President of the Brussels-Africa Hub, highlighted the role and responsibility of diasporas as facilitators and bridge-builders, starting from Brussels as a unique hub of knowledge on EU-Africa relations.
      </p>
      <p class="mt-5">
        The discussion focused on the mechanisms governing the Global Gateway, the need for increased engagement with institutions, and the requirement for a fresh approach to EU-Africa collaboration. Mr. Loïc De Cannière, a board member and head of Incofin Investment Management, facilitated the conversation.
      </p>
      <p class="mt-5">
        Furthermore, the gathering provided an opportunity to gain insights from the Africa-Europe Foundation and their presentation of the "AU-EU Tracker" report. This report offers up-to-date information, data, and expert analysis on the partnership between Africa and Europe.
      </p>
      <p class="mt-5">
        The Brussels-Africa Hub, leveraging its membership in the Global Gateway Dialogue Platform, plans to organize these quarterly informal gatherings to foster the dialogue between the decision-makers  and business community of both continents.
      </p>
    `,
    photos: ["054a07da-50e9-4451-8308-9a39f00febf0.jpeg","4cbf189f-b1be-4bc4-8a9c-465d1f9ca111.jpeg","5b606d21-6feb-4236-b10c-5fc8371e4942.jpeg","6811a62b-9bd3-4f8e-8d45-9f82d1339de0.jpeg","a3e035d1-d21e-4c0f-a81c-6b3b3ed5a99f.jpeg","e562d579-ae32-4ad1-b7fb-ada30ae8f811.jpeg"],
    organizers: [
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
    ],
    sponsors: [
      {
        name: "WTS Global",
        link: "https://wts.com/global",
        logo: process.env.PUBLIC_URL + "/img/partners/wts-global.jpeg",
      },
    ],
  },
  {
    id: "JCrkE081",
    title: "2024 New Year reception",
    dateTime: "2024-01-18",
    location: "Enabel, Brussels, Belgium",
    summary: "On January 18th, the Brussels-Africa Hub hosted a high-level networking reception to mark the first days of Belgium's EU Presidency.",
    banner: "BAH_logo.jpg",
    description: `
      <p class="font-semibold">
        On January 18th, the Brussels-Africa Hub hosted a high-level networking reception to mark the first days of Belgium's EU Presidency. 
      </p>
      <p class="mt-5">
        In his keynote address, <a href="https://www.linkedin.com/in/thomas-stevens-8a15484/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Mr. Thomas Stevens</a>, Deputy Director for Sub-Saharan Africa at the <a href="https://www.linkedin.com/company/belgiummfa/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Ministry of Foreign Affairs Belgium</a>, emphasized the crucial role that Brussels is meant to play in promoting sustainable investment in Africa, while <a href="https://www.linkedin.com/in/soraya-m-hakuziyaremye-2017581/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Mrs. Soraya Hakuziyaremye</a>, Vice-Governor of the <a href="https://www.linkedin.com/company/national-bank-of-rwanda-bnr-/" target="_blank" rel="noopener noreferrer" class="text-blue-500">National Bank of Rwanda</a>, highlighted the measures being implemented to attract global financial players and investors to Rwanda.
      </p>
      <p class="mt-5">
        The event was organized in collaboration with the Belgian development agency (Enabel) and started with an opening speech by <a href="https://www.linkedin.com/in/sven-huyssen-7aa91b15/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Mr. Sven Huyssen</a>, Director of Operations at <a href="https://www.linkedin.com/company/enabel/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Enabel</a>. 
      </p>
      <p class="mt-5">
        It brought together more than 100 high-ranking representatives from EU and Belgian institutions, banks, business advisory firms, and academia. Several members of the African diplomatic corps were also present at the event.
      </p>
      <p class="mt-5">
        As Belgium assumes the <a href="https://www.linkedin.com/showcase/eu2024be/" target="_blank" rel="noopener noreferrer" class="text-blue-500">Belgian Presidency of the Council of the European Union 2024</a>, it is presented with a significant opportunity to guide the EU towards a stronger partnership with Africa and a more ambitious involvement of the private sector, all amidst a complex geopolitical landscape.
      </p>
    `,
    photos: ["0309ce7f-5db4-4630-a4b3-ee513f7e21dd.jpg","04188ebc-90ce-4b44-9694-aac02820e3cc.jpg","057262f0-507c-49dc-a33b-22b2aa502384.jpg","071b56c8-2fdb-4dbb-9e67-d033008ad168.jpg","07d2f54a-57ca-435c-83e9-ccbded1ce7c3.jpg","08275a82-56e6-46da-aa90-9d0d2313d57c.jpg","089afeee-c4f9-45c4-8b59-81da9db0719c.jpg","08e5f037-788f-4e8a-9995-e34a0279b352.jpg","09d10946-4805-4ac6-b103-ff73679f6322.jpg","09db3597-c122-4e7a-8662-09a8eac44e29.jpg","0ace4cf1-1270-4226-a81d-952e4d0a4557.jpg","0b28c851-84a3-4287-8ad8-7ec4d2325bae.jpg","0c58950c-fc1c-4394-87ff-88ba7f8c4f55.jpg","0d10e9fe-1e9c-403a-b4bd-4cd49b1d1add.jpg","0d2dbb01-f046-418e-bf13-20b0c8702bfe.jpg","0d3762ad-45e2-4356-8a96-9966d856a3bb.jpg","0f83c9bb-6dc8-419f-9d83-49f4b6c624aa.jpg","195dca03-c21a-40a9-8e76-d8ba49e1a5e9.jpg","1aac2359-a34c-4e15-8ae3-208eeb5cdbc9.jpg","1d4aa5d8-8e80-4cf5-91e9-97fa537ca556.jpg","1d556cef-495a-44db-b806-cbf767a425fd.jpg","1ee2b9c4-44d7-4ee1-99fc-5063301baca1.jpg","1f17e0cb-3d46-4412-a8d2-205db0ec15ca.jpg","21ecdce6-859e-45e4-a520-4ca87b921830.jpg","23aaddff-6699-4e0e-8120-3dc2a514af51.jpg","2ad32c58-4aee-45f3-a73b-b5708e6d8e5b.jpg","2c7e07a6-5bb6-4f79-bd00-38b3d77ff4d8.jpg","2cf01396-75e8-4bd0-86d8-747222f8fe15.jpg","31df96a8-8f99-4b4d-affd-1e6c25b8cef3.jpg","32021b16-e4ce-4ae1-b0da-12dba6d8f4fe.jpg","39e2bcfe-1bc9-41ab-8416-beaca0b55a34.jpg","3b8d9549-3238-4d79-9367-ce123eaaf845.jpg","3c2b8f29-aa96-4319-adb2-af142fe3a094.jpg","3e46868b-625a-488a-892a-f1381e724c31.jpg","3ebebb34-86ad-4ccf-afed-340d1c25302f.jpg","3fae8f85-eb6d-4263-a916-5b548ce89f11.jpg","41d6e167-a409-4a45-8f3a-f6483d516b4f.jpg","478875c2-bc33-4d6f-8503-4cb1f49a6d99.jpg","49a3f40d-7470-432a-82d7-4ea381adc139.jpg","4cc54a46-3ec2-41f8-824a-e3a2c7525be9.jpg","4d70ed86-c12f-4ff7-9267-60deb740b25d.jpg","4eccae7b-4e2d-4e7a-80e2-1eb444b0f10f.jpg","586384f4-29f2-4482-91a7-9806fc97606c.jpg","604be31b-8da6-41fd-86a0-bf8da6947a94.jpg","605672e3-8a8b-47cd-b02e-62c7c19309e5.jpg","63a52094-46c7-407c-bd92-1d7b87955788.jpg","64bc83f5-7f39-4355-ae09-e44d0c85ed47.jpg","67d60cbc-8f66-4c65-aee9-77c15c88f0db.jpg","67fe9918-168b-44fc-924b-3b40013525c0.jpg","6a57faaf-b01b-4460-b3fa-a6c867895859.jpg","758628da-350e-45b7-bdf9-6348495c007b.jpg","78400449-edfc-498f-8cb7-fb75930a15c9.jpg","78e7cb66-07fb-4d8f-86d6-ac32d63507fe.jpg","7c57bf9b-5af6-4f46-ab09-d77f828eb8aa.jpg","7c87e3a9-fcd5-47ae-9bea-31fb209ec53e.jpg","7d8cd48c-fa25-4ccd-9c0a-5ede69cdc560.jpg","840f711f-d18c-4041-808b-500bacd50058.jpg","84383309-03c9-458d-9648-d0dc4d94f372.jpg","84b86eb5-19ca-4f2e-ae45-d46e60f65ced.jpg","84f9d6a9-359e-4369-8a21-1bb8d9287d06.jpg","879a5094-e00f-4707-87eb-f38a2d574052.jpg","87d1e8c9-b384-4011-9212-ba93bd1de8e1.jpg","8fde0942-bdf6-4552-aba0-bd62c3adfda9.jpg","94326cc7-02c7-4a26-92f0-a285d95db7a2.jpg","9a15677c-74fc-48db-8176-0e4343fdb701.jpg","9eb8202e-0e3c-413c-8a20-43628ee687a5.jpg","a2dad692-9b35-484b-a0ba-5dc148dae421.jpg","acf2b0c0-684d-4f72-94ed-395c8dc57460.jpg","b002169e-88f7-4e28-a5f0-2f8be34c6dac.jpg","b0a5a7bb-bf79-424e-9503-12eaedc2b499.jpg","b0fc4213-ef5a-4eea-93a1-2986889ae775.jpg","b16e9d2c-7cf4-436a-b149-3986c656227a.jpg","b3586235-e310-4866-a7f6-e1521743d010.jpg","b6958534-c17b-4d7b-80d8-18c773ff912c.jpg","b99a72d5-a072-41e7-a64b-f604b5671908.jpg","c112bd65-5073-4ae9-a139-6064bbf500d4.jpg","c2987a6b-2106-4a8f-94a6-f820415cd646.jpg","c64de9f8-020c-4440-aa4b-d9a935284f32.jpg","c70acf02-a67d-487b-9413-e5552212b675.jpg","cc3db1d5-887d-4287-8d19-0429a62f6163.jpg","cef55aa6-847d-457f-aebf-07cea1fcbc37.jpg","cf9e9163-186f-4f06-97dd-30f998cdfb2e.jpg","cfbb2316-3931-4800-94ef-66881a6caa6b.jpg","d02f9861-b6c0-4bce-acad-c6cc8fadc13d.jpg","d295975c-ff6d-4529-b7b9-ebc67d6f671d.jpg","d861e469-f4c2-4cbb-b7cc-d56b4c764fe7.jpg","d9cb0862-b03d-465d-945e-42b37445abcb.jpg","daaaf6eb-7b29-471d-95f9-acadb25993a1.jpg","dc36907d-6bcb-43fa-82e2-5fb9cd2abbf2.jpg","e0098221-1b3e-4700-8f52-c45dda72a438.jpg","e1c6ff1d-a276-4653-95d9-d726aea3154a.jpg","e3c81437-afac-46d1-8bb7-ad7fd3c4104f.jpg","e4ff4c18-e7e0-401d-a0e1-3fe2429062fb.jpg","e8598536-39d4-45d9-bf02-b4d71c2fc63f.jpg","e994208e-c9c6-4ea1-ac69-f10143b33a8f.jpg","ebc6205c-7270-47ce-ae9f-f28a6118154d.jpg","edd17eb7-3cd2-4bea-add1-d6ce0d11d822.jpg","ee125283-9cb2-4711-8dbf-30ef4d0e14d3.jpg","ef19766e-496c-4608-9055-e0e1796cebb5.jpg","f261dc7f-43fe-473e-8a5b-ccb368fd1cba.jpg","f3cca1e4-a4d3-4090-a180-8042e7c07fdf.jpg","f6174f3f-841e-462a-abd5-33d47df92b2c.jpg","f61a40f7-87cf-40da-a20f-a15309aafc9c.jpg","f73a548a-9767-46e7-a4bb-02ba427c8117.jpg","f813a00d-78fc-4f47-9d04-27745991262a.jpg","f86e5725-8fe3-4732-8cb4-1c6cbaf74d8b.jpg","fa218ebb-905f-4d5c-800e-af1868c890e5.jpg","fb91ac8c-c316-494e-aeb0-a5314fb149ac.jpg","fc355b60-3e0f-45ac-a48a-93ed955f7c0c.jpg","fd15638f-58d7-4e2b-8e91-f3df3f50db0b.jpg","ff985903-a736-49b5-9be3-dc4972c2062c.jpg"],
    organizers: [
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
      {
        name: "Enabel",
        link: "https://www.enabel.be/",
        logo: process.env.PUBLIC_URL + "/img/partners/enabel.svg",
      },
    ],
  },
  {
    id: "mJuG4k9J",
    title: "INSEAD 'Financial Statement Analysis and Valuation' executive programme",
    dateTimeFrom: "2023-10-30",
    dateTimeTo: "2023-11-03",
    location: "Kigali, Rwanda",
    summary: "Financial Statement Analysis and Valuation provides you with a comprehesive framework for financial statement analysis and valuation and a framework that integrates strategy, financial reporting, financial analysis and valuation and the application of this framework to fundamental analysis.",
    banner: "INSEAD.jpg",
    description: `
      <p>
        This programme provides comprehensive financial statement analysis and valuation framework that integrates strategy, financial reporting, financial analysis and valuation, and the application of this framework to fundamental analysis.
      </p>
      <p class="mt-5">
        By the end of the course, participants should be comfortable with using firms' financial statements to develop an understanding of their performance and to establish a basis for making reasonable valuation estimates.
      </p>
      <p class="mt-5">
        We will use the case method almost exclusively in this course. The course develops an accounting-based valuation framework that integrates a firm's strategy, its financial performance, and its accounting credibility. Two main topics will be covered:
      </p>
      <ul class="mt-5 list-disc pl-5">
        <li class="mt-2">Reporting strategy analysis: assessing a firm's value proposition and identifying key value drivers and risks; evaluating the degree to which a firm's accounting policies capture the underlying business reality; assessing a firm's earnings quality; making accounting adjustments to eliminate management biases.</li>
        <li class="mt-2">Performance analysis and valuation: evaluating current performance and its future sustainability, making forecasts of future profitability and risk, and valuing businesses using earnings and book value data.</li>
      </ul>
      <p class="mt-5">
        Next, the course applies the above framework to a variety of business valuation contexts, such as, mergers and acquisitions (M&A), leveraged buyouts (LBOs), hedge fund investors and sell side analysts.
      </p>
      <p class="mt-5 font-bold">Key benefits</p>
      <p class="mt-2">
        Upon completing the programme, you will be able to:
      </p>
      <ul class="mt-0 list-disc pl-5">
        <li>Understand accounting's role in business and master the language of accounting</li>
        <li>Learn and apply key concepts of financial accounting</li>
        <li>Identify red flags in financial statements</li>
        <li>Calculate ratios and develop a sound financial statement analysis (e.g.; ROIC and its components)</li>
        <li>Understand solvency financial statistics that measure financial health</li>
        <li>Understand the relevance of capital structure for both performance and valuation</li>
        <li>Understand the trends and sustainability of financial performances overtime</li>
        <li>Develop forecasts and conduct valuation analysis</li>
        <li>Link forecast to the generation of cash flow</li>
        <li>Value companies in different contexts (e.g., M&A, LBO)</li>
      </ul>
      <p class="mt-5">
        Find the program <a href="https://www.insead.edu/executive-education/partner-programmes/financial-statement-analysis-and-valuation" target="_blank" rel="noopener noreferrer" class="text-blue-500">on the INSEAD website</a> or <a href="https://images.marketing.insead.edu/Web/INSEAD/%7B202a2e2b-3346-479f-ab69-32e8b9cb9664%7D_Financial_Statement_Analysis_and_Valuation_-_INSEAD.pdf" target="_blank" rel="noopener noreferrer" class="text-blue-500">download the brochure</a>
      </p>
    `,
    agenda: [
      {
        title: "Day 1: Accounting Analysis and Earnings Quality",
      },
      {
        title: "Day 2: Accounting Analysis (continued) + Financial statement Analysis",
      },
      {
        title: "Day 3: Forecasting + Valuation Theory",
      },
      {
        title: "Day 4: Valuation",
      }
    ],
    programDirectors: [
      {
        name: 'Sharon P. Katz',
        image: process.env.PUBLIC_URL + '/img/events/2023-insead-financial-statement-analysis-and-valuation-executive-programme/directors/sharon-p-katz.jpg',
        profileURL: 'https://www.insead.edu/faculty/sharon-p-katz',
        position: 'Professor of Accounting and Control at INSEAD',
        bio: "Sharon P. Katz is Professor of Accounting and Control at INSEAD. Prior to joining the faculty at INSEAD in 2018, he was a member of the faculty at Columbia Business School from 2010 to 2018, and at Harvard Business School from 2006 to 2010. Professor Katz received his Ph.D. in Business Administration, with distinction, from Columbia Business School. He also earned an MBA from UCLA, which he completed with honors, and a B.A. in Economics and an LL.B. in Law (dual degree) from Tel Aviv University, completing both Magna Cum Laude. Following his MBA, Professor Katz worked for the Investment Banking Division of Citigroup, specializing in Mergers and Acquisitions. He also worked as a corporate lawyer and served in the Israeli Air Force."
      },
    ],
    targetAudience: `
      <p>
      This course is aimed at all midlevel to senior-level executives who seek to use financial statements to evaluate the performance, prospects, and value of a business.
      For example:
      </p>
      <ul class="list-disc pl-5">
        <li class="mt-2">Professionals - for assessing/valuing companies <i>(Corporate & Retail bankers, Money managers, Financial analysts, Investment bankers, Venture capitalists, Risk managers, Auditors, Board members)</i></li>
        <li class="mt-2">General managers and entrepreneurs - interested in accessing public capital markets or acquiring other companies</li>
        <li class="mt-2">Individual investors - for stock picking</li>
      </ul>
    `,
    partners: [
      {
        name: "INSEAD",
        link: "https://www.insead.edu/",
        logo: process.env.PUBLIC_URL + "/img/partners/insead.png",
      },
      {
        name: "Kigali International Financial Centre",
        link: "https://www.rfl.rw/",
        logo: process.env.PUBLIC_URL + "/img/partners/kigali-international-financial-centre.jpg",
      },
      {
        name: "Rwanda Bankers' Association",
        link: "https://rba.rw/",
        logo: process.env.PUBLIC_URL + "/img/partners/rwanda-bankers-association.jpg",
      },
      {
        name: "Rwanda Finance Limited",
        link: "https://www.rfl.rw/",
        logo: process.env.PUBLIC_URL + "/img/partners/rwanda-finance-limited.jpg",
      },
      {
        name: "Rwanda Development Board",
        link: "https://rdb.rw/",
        logo: process.env.PUBLIC_URL + "/img/partners/rwanda-development-board.jpg",
      },
    ],
  },
  {
    id: "4iy0CYcv",
    title: "Europe-Africa Impact Investing Summit",
    dateTime: "2023-09-14",
    location: "The Avenue Conference Centre & Event Venue, Cape Town, South Africa",
    summary: "Join us at the Europe-Africa Impact Investing Summit in Cape Town for thought-provoking discussions on incorporating impact throughout the investment lifecycle. Engage with investors, visionary entrepreneurs and industry experts to explore innovative solutions and collaborate on creating a better future for all.",
    banner: "banner.png",
    description: `
      <p>Join us at the Europe-Africa Investing Summit and be a part of an exciting movement to solve some of the most pressing social and environmental challenges facing Africa today.</p>
      <p class="mt-5">Engage in thought-provoking discussions, explore innovative solutions, and collaborate with visionary leaders to create a better future for Africa and beyond. Topics will be focused on incorporating impact throughout the investment lifecycle and in addition will include the role of Europe-Africa collaboration on clean and affordable energy in fostering impact investing.</p>
      <h3 class="mt-5 font-bold">ABOUT THE SUMMIT</h3>
      <p class="mt-5">This Impact Investing Summit will serve as a pivotal platform for constructive dialogues between European and African partners, centred upon impact investing between European and African partners.</p>
      <p class="mt-5">This is no ordinary conference; it's a dynamic gathering of game-changers, innovators, and leaders who are passionately committed to making a real difference in the world. Throughout the summit, we will shatter limits, ignite fiery debates, and explore bold new approaches to achieve transformative and concrete impact.</p>
    `,
    agenda: [
      {
        title: "Registration",
        dateTime: "2023-09-14T08:00:00+02:00",
        description: `
        `,
      },
      {
        title: "Keynote",
        dateTime: "2023-09-14T09:15:00+02:00",
        description: "Address by Dr Emmanuel Taban, author of “The Boy Who Never Gave Up” and passionate investor in the education of African students"        ,
      },
      {
        title: "Opportunities and threats of investing in Africa: Session 1",
        dateTime: "2023-09-14T10:00:00+02:00",
        description: "Navigating the South African Risk Frontier: Unveiling Challenges and Cultivating Solutions for a Resilient Future by Nicola Comninos",
      },
      {
        title: "Coffee break",
        dateTime: "2023-09-14T10:45:00+02:00",
        description: null
      },
      {
        title: "Opportunities and threats of investing in Africa: Session 2",
        dateTime: "2023-09-14T11:15:00+02:00",
        description: "Development for impact: A use case from a metropolitan city near Cape Town by Caroline Sohie, Leszek Dobrovolsky, Vusi Nondo & Catherine Stone",
      },
      {
        title: "Opportunities and threats of investing in Africa: Session 3",
        dateTime: "2023-09-14T12:15:00+02:00",
        description: "The Potential vs the Pitfalls of investing in an African Project (a Southern African perspective) by Moshie Ratsebe, Jan Fourie, Adrian Dommisse, Hendri Herbst & Neethling van Heerden",
      },
      {
        title: "Lunch",
        dateTime: "2023-09-14T13:00:00+02:00",
        description: null
      },
      {
        title: "Opportunities and threats of investing in Africa: Session 4",
        dateTime: "2023-09-14T13:45:00+02:00",
        description: "How to attract European Institutional Investors in Africa by Kameel Keshav CA (SA), Morne Edas, Revel Wood & Mpho Ratladi"
      },
      {
        title: "Measuring and reporting impact",
        dateTime: "2023-09-14T14:30:00+02:00",
        description: "Measuring and Amplifying Impact: Navigating Sustainable Investment in Emerging Markets by Kaashifah Beukes, Coenraad Bezuidenhout, Khomotšo Grace Legodi & Keoleboge Malela"
      },
      {
        title: "Coffee break",
        dateTime: "2023-09-14T15:15:00+02:00",
        description: null
      },
      {
        title: "The role of the Europe-Africa collaboration on clean & affordable energy: Session 1",
        dateTime: "2023-09-14T15:45:00+02:00",
        description: "Enabling impact through partnerships: The potential transformative impact of green hydrogen on local economies by Aldrich Louis"
      },
      {
        title: "The role of the Europe-Africa collaboration on clean & affordable energy: Session 2",
        dateTime: "2023-09-14T16:30:00+02:00",
        description: "The role of the Europe-Africa collaboration on clean & affordable energy by Chris Yelland, Mamadou Fall Kane, Patrick Stein-Kaempfe, George van Rensburg & Patrice Viaene"
      },
      {
        title: "Cocktail networking reception",
        dateTime: "2023-09-14T18:00:00+02:00",
        description: `
          <a href="https://newmarkhotels.com/dining/ginja-restaurant" target="_blank" rel="noopener noreferrer" class="text-blue-500">Ginja</a> restaurant (walking distance from the venue)
        `
      },
    ],
    speakers: [
      {
        name: "Adrian Dommisse",
        position: "Director & Founder of Dommisse Attorneys Inc",
        profileURL: "https://www.linkedin.com/in/adrian-dommisse-0b198a1a/",
        photo: "adrian-dommisse.webp",
        bio: `
          <p>Prior to establishing Dommisse Attorneys in 2009, Adrian worked with diverse law firms and financial institutions, both locally and in the UK. With roles spanning from being an attorney to an investment banker, he built up valuable experience and expertise which has enabled him to add real value to some of South Africa's leading tech businesses including Getsmarter, Snap Scan, Yuppie Chef, WooThemes and Offerzen.</p>
          <p>Some projects Adrian has been involved in include:</p>
          <ul>
            <li>The lead attorney for Yuppiechef in their sale to Mr Price Group</li>
            <li>Advises venture capital funds including Knife Capital, and establishing Imperials' Global (UK and SA-based) $20million venture capital fund working with Newtown Partners</li>
            <li>Advises the University of Stellenbosch and University of Cape Town technology spin-out units</li>
          </ul>
          <p>In 2022 Adrian established IP Incubator to empower clients to attract offshore funding and build global wealth, by housing their IP offshore.</p>
        `
      },
      {
        name: "Aldrich Louis",
        position: "General Manager at ArcelorMittal South Africa",
        profileURL: "https://www.linkedin.com/in/aldrich-louis-53884577/",
        photo: "aldrich-louis.webp",
        bio: `
          <p>Aldrich Louis is a seasoned professional with a strong background in the steel industry, currently serving as the General Manager at ArcelorMittal Saldanha Works. Holding a Chemical Engineering degree from the University of Stellenbosch and an MBA from the University of Cape Town, Aldrich possesses a blend of technical and business expertise.</p>
          <p>ArcelorMittal Saldanha Works is a mothballed plant, that lends itself to the production of Green Iron and Green Steel due to its existing infrastructure. It is well positioned to be South Africa's 1st large scale off-taker of green hydrogen, bringing back lost jobs, creating new jobs, and diversifying an economy that is very highly reliant on fishing - a dwindling industry due to declining fish stock.</p>
        `
      },
      {
        name: "Caroline Sohie",
        position: "Architecture Director at Instinct",
        profileURL: "https://www.linkedin.com/in/caroline-sohie/",
        photo: "caroline-sohie.webp",
        bio: `
          <p>Caroline is the architecture director and co-founder of INSTINCT, an international architectural practice and design agency with satellites in Cape Town and Brussels. Dedicated to delivering forward-thinking projects and solutions, INSTINCT operates as a team of creatives and specialists from around the world stemming from diverse disciplines, ranging from architects, urban designers, engineers, strategists, to social scientists.</p>
          <p>Previously, Caroline led a wide-ranging international design portfolio for the global design and engineering company Ove Arup & Partners in London, ranging from rail & urban mobility, aviation to projects in sports, commercial to culture, education and urban planning, and led the architectural offering for Africa for a number of years.</p>
          <p>With two decades of experience, she is recognised for her design leadership of public architectural and large -scale infrastructure environments around the world, including Latin America, Europe, Africa, Middle East and Asia. Caroline's completed projects demonstrate a strategic and creative approach towards urban infrastructure as a foundation for urban regeneration, integrated development visions and sustainability.</p>
        `
      },
      {
        name: "Catherine Stone",
        position: "Director Spatial Planning at Western Cape Government",
        profileURL: "https://www.linkedin.com/in/catherine-stone-87b4479a/",
        photo: "catherine-stone.webp",
        bio: `
          <p>Catherine Stone is a built environment, public sector governance specialist and professional urban planner. Her practice is focussed on the integration of development planning with public finance and sector planning - towards more practical and implementable plans that achieve the spatial transformation of South African cities, with a particular passion for well-located affordable housing. Catherine has 24 years of professional experience in the public, private and non-profit sectors in South Africa and the UK. 11 of these years were in senior management in local government for the most part as the former Director of Spatial Planning and Urban Design at the City of Cape Town. Catherine is currently the Director of Spatial Planning in the regional government of the Western Cape.</p>
        `
      },
      {
        name: "Chris Yelland",
        position: "Energy Analyst & Journalist",
        profileURL: "https://www.linkedin.com/in/chrisyelland/",
        photo: "chris-yelland.webp",
        bio: `
          <p>Chris Yelland is an accomplished energy and engineering analyst with a strong focus on the electricity and energy sectors in South Africa and the region. With over two decades of experience, he has become a leading voice in South Africa's energy landscape. Chris is renowned for his advocacy of renewable energy technologies and his efforts to reduce South Africa’s reliance on fossil fuels.</p>
          <p>In addition to his engineering expertise, Chris has made significant contributions as a journalist, with his insightful reporting and analysis earning him several prestigious journalism awards. His expertise and commentary have shaped discussions and policies in the sector, fostering a more sustainable approach to power generation.</p>
          <p>His passion for clean energy solutions and his dedication to informing and inspiring change make him an influential voice in the field. He continues to pave the way for a more sustainable and reliable energy future, both in South Africa and beyond.</p>
        `
      },
      {
        name: "Coenraad Bezuidenhout",
        position: "Principal at BrightWolves South Africa",
        profileURL: "https://www.linkedin.com/in/coenraad-bezuidenhout-75780018/",
        photo: "coenraad-bezuidenhout.webp",
        bio: `
          <p>Coenraad is a recognized leader in the field of sustainability, with 20 years' experience across government, the legislative environment, organised business and corporate and independent developmental consulting. With a distinguished career, he brings a depth of expertise that will undoubtedly enhance the depth of discussion. With academic credentials from institutions like Cambridge and Boston University, he brings a great mix of industry experience coupled with academic expertise.</p>
          <p>Coenraad is a Principal at BrightWolves South Africa, a management consulting company with bases in both Belgium and South Africa. BrightWolves has grown into a highly respected business, sustainability, and digital transformation consultancy, thanks to a great team of consultants and senior experts, with a bias for action and driving impact, from strategy to implementation.</p>
        `
      },
      {
        name: "Emmanuel Taban",
        position: "Director & Partner at The Lung Institute",
        profileURL: "https://www.linkedin.com/company/emmanuel-taban-foundation/people/",
        photo: "emmanuel-taban.webp",
        bio: `
          <p>Introducing Dr. Emmanuel Taban, a highly qualified and influential pulmonologist named one of the 100 Most Influential Africans in 2020 by New African Magazine. With a remarkable journey from walking across multiple countries in search of education to pioneering a novel technique of mucus extraction from the lungs during Covid-19, Dr. Taban's life is an extraordinary tale of resilience and determination.</p>
          <p>His dedication as a physician led to important discoveries in the treatment of hypoxaemic COVID-19 patients. Rising above extreme poverty, racism, and xenophobia, he has become a true South African legend, leaving an indelible mark on the field of medicine and inspiring countless individuals worldwide.</p>
          <p>While he has achieved immense success in his chosen profession of medicine, driven by a passion for patient care and excellent delivery of healthcare services, he remains concerned about the dire circumstances that many African children face due to a lack of good quality education.  Aiming to assist in addressing this gap, The Emmanuel Taban Foundation was established by Dr Taban and his wife Motheo Phalatse-Taban.</p>
          <p>Additionally, he has published his own autobiography called “The Boy Who Never Gave Up”.</p>
        `
      },
      {
        name: "George van Rensburg",
        position: "CEO at Keren Energy Group Holdings (Pty) Ltd",
        profileURL: "https://www.linkedin.com/in/george-van-rensburg-b057a9274/",
        photo: "george-van-rensburg.webp",
        bio: `
          <p>George van Rensburg through Keren Energy has been developing renewable energy projects across Southern Africa in last decade.</p>
          <p>Keren Energy has successfully developed renewable energy projects in the SA Government’s REIPPP programme.</p>
          <p>George and the Keren team developed the first proof of concept green hydrogen project in Africa in the town of Vredendal.</p>
          <p>Keren with its partners are finalising their bankable feasibility on their first 10mw green hydrogen commercial project in Vanrhynsdorp.</p>
        `
      },
      {
        name: "Hendri Herbst",
        position: "Tax Specialist at WTS Renmere",
        profileURL: "https://www.linkedin.com/in/hendri-herbst-09807816a/",
        photo: "hendri-herbst.webp",
        bio: `
          <p>Hendri specialises in corporate tax, international tax and the taxation of trusts. He obtained a Masters degree in law from Stellenbosch university, with the emphases on international tax law, trust law and company law. His doctoral thesis built on the aforesaid topics, focusing specifically on the income tax treatment of trusts. Hendri’s expertise is not only limited to South Africa, but extends to a number of jurisdictions. Prior to joining Renmere in 2023, he was involved in academia in South Africa and abroad.</p>
        `
      },
      {
        name: "Jan Fourie",
        position: "Executive Vice President - Sub Sahara Africa at Scatec ASA",
        profileURL: "https://www.linkedin.com/in/jan-jurie-fourie-28247a7/",
        photo: "jan-fourie.webp",
        bio: `
          <p>Jan Fourie is the EVP for Scatec in Sub-Saharan Africa, a leading global and domestic renewable energy solutions provider and multi technology company that is accelerating access to reliable and affordable clean energy in high growth markets. Jan began his career as an engineer working in the energy sector and has gained vast experience in the project and infrastructure environment of both renewable and mineral industries.</p>
        `
      },
      {
        name: "Jean Van Wetter",
        position: "CEO of Enabel",
        profileURL: "https://www.linkedin.com/in/jean-van-wetter-a5a574/",
        photo: "jean-van-wetter.webp",
        bio: `
          <p>20 years of experience working for international firms and development organizations in Europe, Asia and Africa, leading international and multi-functional teams in different contexts, implementing ambitious development strategies and delivering on results.</p>
        `
      },
      {
        name: "Kaashifah Beukes",
        position: "Chief Executive Officer at Freeport Saldanha",
        profileURL: "https://www.linkedin.com/in/kaashifah-beukes-8432ba2a/",
        photo: "kaashifah-beukes.webp",
        bio: `
          <p>Kaashifah Beukes is the Chief Executive Officer of the Saldanha Bay IDZ Licencing Company SOC Ltd, trading as Freeport Saldanha, since 2019. The Freeport is one of a handful of special economic zones across South Africa, and it is located in and around the Port of Saldanha Bay in the Western Cape.</p>
          <p>In her role, she leads the implementation of the vision and strategies of the Freeport. She has considerable experience in successfully leading people and teams through issues of complexity and risk, and is passionate about making a sustainable, transformative impact, especially at the community level. She has experience in Strategic Planning & Execution, Forming Strategic Relationships, Risk & Crisis Management, Negotiations, Stakeholder Management and Project Management & Execution.</p>
          <p>Kaashifah holds a BSc in Civil Engineering and an MBA from the University of Cape Town.</p>
        `
      },
      {
        name: "Kameel Keshav CA (SA)",
        position: "Deal maker and C-suite Executive",
        profileURL: "https://www.linkedin.com/in/kameelkeshav/",
        photo: "kameel-keshav.webp",
        bio: `
          <p>Kameel boasts an extensive reservoir of expertise spanning two decades within the property, telecommunications, and FMCG industries. His remarkable track record is underscored by adeptness in corporate finance, management, and strategy, showcased across a diverse array of sectors. A distinguished Harvard University alumnus, Kameel has graduated from the Advanced Management Development Program in Real Estate, complementing his credentials as a seasoned Chartered Accountant with 19 years of professional practice. His portfolio encompasses leadership roles as both CEO and CFO in JSE listed and private enterprises, alongside participation as an executive and non-executive board member. Notably, he co-founded and helmed the Inkunzi Student Accommodation Fund, a specialized venture in student accommodation which he spearheaded the JSE listing process and secured JSE approval.. Kameel currently lends his expertise as an Independent Non-Executive Director to the Brussels Africa Hub (the co-organisers of the event) based in Belgium.</p>
        `
      },
      {
        name: "Keoleboge Malela",
        position: "ESG and Impact Manager at Norsad Capital",
        profileURL: "https://www.linkedin.com/in/kay-malela-4926034b/",
        photo: "keoleboge-malela.webp",
        bio: `
          <p>Keoleboge Malela holds a BSc degree in Environmental Health from the University of Botswana and is currently pursuing an MSc in Sustainable Development with the University of Sussex. She has ISO14001 (Environmental Management) accreditation from the Botswana Bureau of Standards, and has also completed specialised ESG trainings from the UN Principles of Responsible Investment Academy. She has broad experience in social research and natural resource management.</p>
          <p>Keoleboge is currently the ESG & Impact Manager at Norsad Capital, an impact investor and private credit provider offering debt and mezzanine finance to mid-market growth companies in Africa. Norsad’s purpose is to build a better Africa by supporting the growth of profitable African companies through tailor-made debt finance solutions, enabling them to have substantial and ongoing social impact through the services and employment they provide.</p>
        `
      },
      {
        name: "Khomotšo Grace Legodi",
        position: "Senior Investment Officer at Untapped Global",
        profileURL: "https://www.linkedin.com/in/khomot%C5%A1o-grace-legodi-64038b1a/",
        photo: "khomotso-grace-legodi.webp",
        bio: `
          <p>Grace Legodi is an all-round investment professional with 10+ years experience working with international financial institutions and start-ups/SMEs in Southern Africa and the United States. She is a Senior Investment Officer at Untapped Global, a revenue based smart asset financing firm to startups across Africa. She also serves on the advisory/investment committee/board of directors of various public and private sector ventures focused on early stage green economy, financial services and property sectors.</p>
          <p>She most recently consulted to The World Bank Group, helping them execute on Entrepreneurship Ecosystem Development in Southern Africa. Prior to this, she gained experience in start-up acceleration and early stage investing from the private sector at Grindstone (South Africa based) as Africa Director and at Plug and Play Tech Center as South Africa Director, Country Manager (California based). The majority of her work experience to-date is in Investment Banking. This experience was gained over 10 years, 5 years of which was spent working in M&A at Goldman Sachs based in New York and Johannesburg. She was also on the Ambassador Board of Launch with GS, Goldman Sachs’ first for-profit initiative to invest in diverse, women-founded, owned and/or -led businesses in the U.S.</p>
          <p>She holds a Bachelor Business Science, Finance (Honours) Degree from the University of Cape Town and a Masters in Innovation and Entrepreneurship from HEC Paris (Summa Cum Laude).</p>
        `
      },
      {
        name: "Leszek Dobrovolsky",
        position: "Major Projects Director at Instinct",
        profileURL: null,
        photo: "leszek-dobrovolsky.webp",
        bio: `
          <p>Leszek is the Major Projects director and co-founder of INSTINCT, an international architectural practice and interdisciplinary design agency with satellites in Cape Town and Brussels. Leszek is a recognised expert in the design and planning of complex infrastructure and architectural projects, with a focus on mixed-use transit-oriented developments and intermodal transport interchanges.</p>
          <p>Prior to founding INSTINCT he was a Partner of Ove Arup & Partners in London responsible for the infrastructure, transport and architecture division. His portfolio includes the concept design for a new International Station development at St. Pancras in London and the interdisciplinary design and implementation of the new Channel Tunnel Rail Link Stations at Stratford International and Ebbsfleet International in London, including the co-ordination of the masterplan and regeneration opportunities.

          30 years of experience have been honed through the leadership of over 100 projects in 20 countries.  His range and depth of projects cover the full breadth, from feasibility through to implementation. He is often called upon to provide strategic advice on the viability and development of transit-oriented developments globally, in particular in evolving and dynamic city economies.</p>
        `
      },
      {
        name: "Mamadou Fall Kane",
        position: "Energy Advisor to the President of Senegal",
        profileURL: "https://www.linkedin.com/in/mamadou-fall-kane-1b311b160/",
        photo: "mamadou-fall-kane.webp",
        bio: `
          <p>Mamadou Fall Kane is the Energy Advisor to the President of the Republic of Senegal and the Deputy Permanent Secretary of the Strategic Orientation Committee of COS-PETROGAZ, a steering committee under the authority of the President in charge of coordinating and monitoring of the development of oil, gas and hydrogen in Senegal. Mr. Kane has been actively involved in final investment decision-making for oil and gas projects as well as in major reforms related to the energy sector. Mr. Kane is one of the leading Energy experts on the African continent.</p>
          <p>He joined the office of President Sall in December 2012, as the Advisor to the President in charge of Economics, Finances and Investments. He gained valuable experience at the Treasury Department of the French Ministry of Economics and Finances on issues related to financing the economy and industrial restructuring. He also gained experience at the World Bank and the investment Banking branch of the Credit Agricole Corporate and Investment Banking in Paris.</p>
          <p>He graduated from Sciences Po Paris before completing his education at Ecole Polytechnique of Paris in Economics and Public Policy.</p>
        `
      },
      {
        name: "Morne Edas",
        position: "Founder & Co-Managing Partner at Infra Impact Investment Managers",
        profileURL: "https://www.linkedin.com/in/morn%C3%A9-edas-6951712b/",
        photo: "morne-edas.webp",
        bio: `
          <p>Morné is an accomplished private equity investment professional with a passion for impact infrastructure investment in Africa. He co-founded Infra Impact Investment Managers with its Infra Impact Mid-Market Infrastructure Fund 1 reaching final close with investor commitments of ZAR 2.1 billion, exceeding its target by over 40%. The Fund is deploying capital in line with the teams historically successful mid-market, value-add infrastructure strategy, in the water, waste, energy, telecommunications, and related sectors. Infra Impact believes the market opportunity remains unprecedented, with trillions of Rands of investment required in sustainable infrastructure across South Africa to support job creation and economic growth.</p>
          <p>Previously, he was a consultant for a Sub-Saharan Africa focused impact investing Private Equity fund. Prior thereto, he was an Executive Director and Investment Manager at a Stellenbosch based Private Equity firm, where he served as a non-executive director on the boards of various investee companies. Other roles include that of Investment Analyst and Nuclear Engineer.</p>
          <p>He completed his MBA at UCT full time, which including studies at Cambridge University in the UK. He is a graduate of the Harvard Business School’s Advanced Management Program, and Private Equity & Venture Capital Program, in Boston, USA, as well as a CFA Charterholder. Also, he is a member of the Institute of Directors in Southern Africa (IoDSA), having achieved the professional Chartered Director (SA) designation by the IoDSA.</p>
        `
      },
      {
        name: "Moshie Ratsebe",
        position: "Director of Investment Promotion at BITC",
        profileURL: "https://www.linkedin.com/in/moshie-ratsebe-542a31b/",
        photo: "moshie-ratsebe.webp",
        bio: `
          <p>Moshie Ratsebe is a seasoned professional serving as the Director of Investment Promotion – Financial & Business Services at the Botswana Investment & Trade Centre (BITC). With a keen focus on driving economic growth, Moshie leads the charge in promoting and advancing Botswana's International Financial Services Centre (IFSC). His leadership extends across a comprehensive portfolio encompassing specialized business services such as Finance and Knowledge Intensive Business Services (F&KIBS), Business Process Outsourcing (BPOs), Information and Communications Technology (ICT), Tourism, Health, and Education.</p>
          <p>With a wealth of strategic leadership experience, Moshie’s distinguished career spans both public and private sectors. He previously held the position of Executive Director of International Business at the BITC's Johannesburg-based Regional Office, where he played a pivotal role in amplifying investment and business prospects, channeling foreign direct investments into Botswana's key growth sectors. With an established background in senior roles at leading organizations, including his tenure at AB InBev Group's Kgalagadi Breweries Limited, Moshie's expertise encompasses market insights, commercial management, and project appraisal.</p>
          <p>Moshie holds a Bachelor of Accountancy from the University of Botswana and has further honed his skills through a Management Development Programme at the University of Stellenbosch Business School in South Africa, solidifying his reputation as an accomplished leader at the dynamic intersection of investment, business, and strategy.</p>
        `
      },
      {
        name: "Mpho Ratladi",
        position: "Finance Director at Norsad Capital",
        profileURL: "https://www.linkedin.com/in/mpho-ratladi-ca-sa-b495012a/",
        photo: "mpho-ratladi.webp",
        bio: `
          <p>Mpho Ratladi holds a BCom degree in Accounting from the University of Johannesburg, an honors degree in Accounting Science from the University of South Africa and is a registered Chartered Accountant / CA (SA). He has a wide range of experience in financial-related roles, including financial reporting, corporate finance, banking, and M&A.</p>
          <p>Mpho is currently the Finance Director at Norsad Capital, an impact investor and private credit provider offering debt and mezzanine finance to mid-market growth companies in Africa. Norsad’s purpose is to build a better Africa by supporting the growth of profitable African companies through tailor-made debt finance solutions, enabling them to have substantial and ongoing social impact through the services and employment they provide.</p>
        `
      },
      {
        name: "Neethling van Heerden",
        position: "Tax Director",
        profileURL: "https://www.linkedin.com/in/neethling-van-heerden-b466013a/",
        photo: "neethling-van-heerden.webp",
        bio: `
          <p>Neethling specialises in corporate and international tax advisory and has extensive experience in mining tax and mineral royalties. He is a qualified chartered accountant holding a law degree and master’s degree in taxation and previously practiced as a corporate tax and transaction advisory specialist at one of the Big 4 accounting firms. Prior to joining Renmere in 2017, Neethling functioned as head of finance and taxation at a prominent mining group.</p>
          <p>Neethling’s clients include listed and unlisted corporates, both local and multinational, as well as high net worth individuals.</p>
        `
      },
      {
        name: "Nicola Comninos",
        position: "Chief Risk Officer at Purple Group",
        profileURL: "https://www.linkedin.com/in/nicola-comninos-cfa-groupcro/",
        photo: "nicola-comninos.webp",
        bio: `
          <p>Nicola Comninos, CFA is a director, a loving partner, a mother of three boys, a seasoned financial markets executive, board member and pension fund board trustee and chair with over 17 years’ experience in group risk, strategy, sustainability, capital markets, trading, investments, and business intelligence. She is passionate about mentorship, financial inclusion, and diversity. Currently she looks after risk, governance, legal, compliance and sustainability as the Chief Risk Officer of Purple Group and its subsidiaries including, but not limited to EasyEquities, EasyCrypto and EasyProperties. As a CFA Charterholder, with investment management degrees she is actively involved in CFA Society, 100 Women in Finance, Women in ETFs and holds non- executive board seats at AfricaGlobal Xchange and the Institute of Risk Management of South Africa.</p>
        `
      },
      {
        name: "Nobuhle Ncube",
        position: "Manager at BrightWolves South Africa",
        profileURL: "https://www.linkedin.com/in/nobuhlencube/",
        photo: "nobuhle-ncube.webp",
        bio: `
          <p>With over a decade of experience, Nobuhle brings a wealth of expertise to her role as a Manager at Brightwolves South Africa, helping clients unravel organizational challenges and develop sustainable solutions.</p>
          <p>She believes that profit does not have to come at the cost of people, their communities or the planet. Previously she served as Chief Strategy Officer at SPARK Schools where she drew on her commercial experience to expand access to technology-driven affordable private education for South African families.</p>
          <p>Nobuhle holds a journalism undergraduate degree from Rhodes University, and obtained her MBA in corporate strategy from Gordon Institute of Business Science (GIBS) in 2018.</p>
        `
      },
      {
        name: "Patrice Viaene",
        position: "Partner at Clifford Chance",
        profileURL: "https://www.linkedin.com/in/patrice-viaene-2a02a314/",
        photo: "patrice-viaene.webp",
        bio: `
          <p>Patrice Viaene is a partner at the Clifford Chance Brussels office. His corporate experience extends across international and domestic M&A, energy, construction and large infrastructure projects as well as assisting entrepreneurs and venture capital investors in the tech sector.</p>
          <p>Patrice has particular expertise in the renewable energy sector and is a leading member of the worldwide Clean Hydrogen Taskforce. From 2014 to 2016 Patrice was partially based in Düsseldorf as a member of the team working on ALEGrO, the Belgian-German TO interconnector project.</p>
        `
      },
      {
        name: "Patrick Stein-Kaempfe",
        position: "Project director at Hyphen",
        profileURL: "https://www.linkedin.com/in/patrick-stein-kaempfe-05ba0b4/",
        photo: "patrick-stein-kaempfe.webp",
        bio: `
          <p>Patrick Stein-Kaempfe is a senior advisor to Enertrag, Germany’s leading renewable energy developer, and a project director at Hyphen, Namibia’s first Gigawatt-scale green hydrogen-to-ammonia project. Patrick is a seasoned private equity professional with experience at leading investment houses H.I.G. Capital, Penta Investments and Cranemere across the US, Europe and Africa. Patrick’s experience in the energy sector includes the successful buyout of Haltermann (today H.C.S. Group), a specialty refinery and a €100 million series E growth capital round for MiaSolé, a CIGS solar PV technology company. Patrick’s experience on the Africa continent further includes the co-founding of Actus Education Africa, an Africa-focused K-12 education holding platform and led successful investments in Kenya’s leading affordable private school chain with 6 schools and close to 5,000 enrolments. Patrick started his career as a project manager at Siemens across a range of global assignments. He holds an MBA and a Master of International Affairs from Columbia University, as well as Master’s Degrees in Engineering from both RWTH Aachen in Germany and Ecole Central Paris in France.</p>
        `
      },
      {
        name: "Revel Wood",
        position: "Co-founder & CEO of ONE Group",
        profileURL: "https://www.linkedin.com/in/revelwood/",
        photo: "revel-wood.webp",
        bio: `
          <p>Co-founder ONE group solutions, the industry leading fund governance provider in Luxembourg. Prior to this, he was group CEO of FundRock, (formerly RBS Luxembourg). At the helm he successfully navigated through the RBS “exit from Luxembourg”, steering the company clear of collapse, going on to grow the rebranded FundRock five fold in three years. Prior to FundRock, as deputy MD and head of business strategy, he led Northern Trust Fund Services in Luxembourg (including ManCo), with growth of 80% in three years during his tenure.</p>
          <p>Revel is not the stereotypical CEO, having come from a working class mining family, recognised for leadership in the military and worked his way through operations, risk management, product and business strategy into two CEO roles. He appreciates the value of looking after hard working peoples savings and sees the greater purpose in what we do in the funds industry, quoted as saying: “I love what we do, with the right team we can have a real positive impact on peoples savings, by build quality solutions for our clients investors that add real value and keep their retirement plans safe.” He is an experienced and energised leader with 30 years of leadership experience, passionate about high quality customer solutions by inspiring a sense of pride and collective ownership in the teams he led.</p>
        `
      },
      {
        name: "Vusi Nondo",
        position: "Development Director of V&A Waterfront, Cape Town",
        profileURL: "https://www.linkedin.com/in/vnondo/",
        photo: "vusi-nondo.webp",
        bio: `
          <p>Vusi Nondo has over 23 years of experience in the design, construction and development of property and property investments garnered mainly in the South African real estate market.</p>
          <p>Initially employed as a Development Portfolio Manager, he went on to develop and acquire new property investments in the residential, office, industrial and retail sectors of the market. He was a member of the Old Mutual Property Executive Committee, responsible for the management of the Old Mutual SRI Real Estate Fund until his departure to initiate a new venture, the Urban Growth Management Company in 2011. He was the General Manager of Development and Investment at Communicare, the oldest social and affordable housing Non-Profit Company (NPC) in South Africa. At present Vusi is the Development Executive of the V&A Waterfront, a 123-hectare mixed-use destination in Cape Town.</p>
          <p>Vusi holds several qualifications including a Bachelor of Commerce Honors Degree in Financial Analysis and Portfolio Management and a Master’s Degree in Business Administration from the University of Cape Town (UCT).  He is also a fellow of the Centre for Leadership and Public Policy Values based at UCT and Duke University, and a Bertha Scholar of the Bertha Centre for Social Innovation and Entrepreneurship based at The Graduate School of Business in Cape Town.</p>
        `
      },
    ],
    photos: ["02ddf9aa-2fcb-42f2-8aaf-9a8d62deef3b.jpg","044d3652-8cbb-46a0-b599-de1a94647aeb.jpg","04f2dfe6-51d7-4173-a75f-47b2a7ac6ab0.jpg","0674b71d-8e0a-4f92-81c1-e3292fd0b3ef.jpg","0e4269d6-d41d-454d-aa11-eda1c5fd6c10.jpg","117185be-6aa7-4b05-b250-353341d68c39.jpg","12200f16-eef4-4d5f-b583-2d92be3fdf67.jpg","1b570f3c-296b-48bf-bfe7-f32cc1da8e51.jpg","2215b765-d73a-47d1-8ea0-463c0fc41178.jpg","28ded90f-cb68-4067-b9e7-706b15c09205.jpg","2bf62934-1897-4650-be4e-7cf92863ebcd.jpg","35fd0de8-f7aa-4ec4-a90b-5ab830a472ad.jpg","3878e9e4-f811-4f21-abf8-685afab07ae1.jpg","3944ffcf-1b54-4dcd-a8c9-3ba6ae6f4c21.jpg","3d94dbd2-42fc-4cc9-b091-a85ee95722cd.jpg","42fedd77-563f-45a4-ad28-117357adabf3.jpg","46bf3f36-d53f-4058-afd2-943bc286f859.jpg","48bcb45a-c2a5-4dee-9fb4-7a5c48671a7d.jpg","4c895917-f181-48f2-9e92-e8592f1fd95c.jpg","74cf1818-89b7-401c-9342-e7fc9116b996.jpg","86cd5a01-6826-4879-84a1-ce532be89d41.jpg","8d6aaa76-3728-4828-9c3f-175f38cd58b2.jpg","8ea748f5-20f9-429e-bf29-9734adb764aa.jpg","97477ba3-c0f1-4413-b378-d9080717b564.jpg","98412191-feea-4d0a-aff7-e341ab3ccc38.jpg","9d1042b5-7f2b-4641-a18b-471dbb805117.jpg","a081a1c2-3a4c-4a3b-b6d1-0027b99c9298.jpg","a2872f8f-9de6-491a-aebd-399ed53c318d.jpg","ad14c6ca-2b48-421b-b683-d2c5d4280c45.jpg","b374cb8d-a88b-4251-a4bd-4b3833890381.jpg","b95751d2-f9e6-4805-bbe6-6fdf6ebc0500.jpg","bcd5ad6a-6845-417d-9ff6-06591f12304e.jpg","c1ccecd4-79c5-4467-b8c3-3868a3bf7460.jpg","c7df9383-d519-4ba1-a280-c2486c708385.jpg","ce8eed75-df81-4e50-88fb-9e4c1da758a3.jpg","dcff0714-fea0-4a17-83a3-fc3e42834197.jpg","e1fdb71d-2ec6-4f36-b85b-5318c64a0891.jpg","e225e0c5-2124-4faf-998a-b580275b52b8.jpg","e58ac39c-70cb-4fdb-af9e-7ce42fd16fa3.jpg","e8299752-4f19-4383-aea4-20092d523a3e.jpg","ed7b385d-b804-4870-a319-886362761174.jpg"],
    organizers: [
      {
        name: "BrightWolves",
        link: "https://www.brightwolves.com/",
        logo: process.env.PUBLIC_URL + "/img/partners/brightwolves.png",
      },
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
    ],
    sponsors: [
      {
        name: "Ethiopian Airlines",
        link: "https://corporate.ethiopianairlines.com/Press-release-open-page/ethiopian-airlines-wins-best-overall-in-africa-award-at-the-2023-apex-passenger-choice-awards",
        logo: process.env.PUBLIC_URL + "/img/partners/ethiopian-airlines.webp",
      },
      {
        name: "Clifford Chance",
        link: "https://www.cliffordchance.com/home.html",
        logo: process.env.PUBLIC_URL + "/img/partners/clifford-chance.webp",
      },
      {
        name: "ENERTRAG",
        link: "https://enertrag.com/windstrom-wasserstoff-speicherloesungen-und-sektorkopplung",
        logo: process.env.PUBLIC_URL + "/img/partners/enertrag.webp",
      },
      {
        name: "Norsad Capital",
        link: "https://norsadcapital.com/",
        logo: process.env.PUBLIC_URL + "/img/partners/norsad-capital.webp",
      },
    ],
  },
  {
    id: "TtdXqTBn",
    title: "Annual Reception 2023",
    dateTime: "2023-06-30",
    location: "The Merode, Brussels, Belgium",
    summary: "On June 30th, the Brussels Africa Hub held its highly anticipated annual reception, showcasing our mission to establish Brussels as the European hub for sustainable investments in Africa.",
    banner: "BAH_logo.jpg",
    description: `
      <p class="text-lg">
        On June 30th, the Brussels Africa Hub held its highly anticipated annual reception, showcasing our mission to establish Brussels as the European hub for sustainable investments in Africa.
      </p>
      <p class="mt-5">
        Our ecosystem of service providers and our network of investors came together with influential diplomats from both continents to explore the next steps for private sector engagement, focusing on innovative financing models and policy frameworks that can bridge the investment gap. 
      </p>
      <p class="mt-5">
        The event, held in sync with our Annual General Assembly, also provided valuable information on new developments and emerging trends that could affect the dynamic EU-Africa business landscape. 
      </p>
      <p class="mt-5">
        In his keynote speech, Mr Bernard Quintin, Deputy Director General Africa at the European External Action Service (EEAS), shared a few insights into the upcoming Belgian presidency of the EU Council. We also took the opportunity to present our executive training project, conducted in partnership with INSEAD, where Mr. Theo Vermaelen, Professor of Finance at INSEAD, joined us remotely all the way from Chicago.
      </p>
      <p class="mt-5">
        Two insightful panels dedicated to Ethiopia and South Africa added another layer of expertise to the event. We were privileged to have both Ambassadors, H.E. Ms Hirut Zemene Kassa and H.E. Ms Tokozile Xasa, open the discussions and shed light on the investment potential in their respective countries. Each panel included perspectives from the private sector, with Mr Gemechis Tujuba, Area manager Benelux at Ethiopian Airlines, and Mr Domien Agten, country manager Brightwolves South Africa, sharing their in-country experience.
      </p>
      <p class="mt-5">
        The event, which concluded with a networking reception, served as platform to emphasize our commitment to help build African bankers' capacity and a strong infrastructure for capital exchange. Moving forward, our main priority continues to be strengthening the financial sector and facilitating the flow of capital as we firmly believe that this will truly unlock Africa's immense economic potential. We look forward to continued partnerships with all stakeholders and building on these promising conversations. Most importantly, we are determined to turn them into tangible action.
      </p>
    `,
    agenda: [
      {
        title: "Welcome & Registration",
        dateTime: "2023-06-30T17:30:00+02:00",
        description: `
        `,
      },
      {
        title: "Introduction",
        dateTime: "2023-06-30T18:00:00+02:00",
        description: `
          <ul>
            <li><b>Mr Mouctar BAH</b></li>
            <li>President Brussels Africa Hub, Member of the Executive Committee Belgian Finance Center</li>
          </ul>
        `,
      },
      {
        title: "Keynote speech",
        dateTime: "2023-06-30T18:05:00+02:00",
        description: `
          <ul>
            <li><b>Mr Bernard QUINTIN</b></li>
            <li>Deputy Director General Africa, European External Action Service (EEAS)</li>
          </ul>
        `,
      },
      {
        title: "Video presentation: INSEAD Executive Training Project in Kigali, Rwanda",
        dateTime: "2023-06-30T18:20:00+02:00",
        description: `
          <ul>
            <li><b>Mr Theo VERMAELEN</b></li>
            <li>Professor of Finance at INSEAD</li>
          </ul>
        `,
      },
      {
        title: "Country focus panel: Ethiopia",
        dateTime: "2023-06-30T18:45:00+02:00",
        description: `
          <ul>
            <li><b>H.E Hirut ZEMENE KASSA</b></li>
            <li>Ambassador of Ethiopia to Belgium, Luxembourg, the Netherlands & the EU Institutions</li>
            <li><b>Mr Gemechis TUJUBA</b></li>
            <li>Area Manager BeNeLux Ethiopian Airlines</li>
            <li><b>Mr Thewodros BERHANU (Moderator)</b></li>
            <li>Board Member Brussels-Africa Hub, President BelgoEthiopian Business Club, Founder Europe Africa IP</li>
          </ul>
        `,
      },
      {
        title: "Country focus panel: South Africa",
        dateTime: "2023-06-30T19:10:00+02:00",
        description: `
          <ul>
            <li><b>H.E. Tokozile XASA</b></li>
            <li>Ambassador of South Africa to Belgium, Luxembourg & the EU Institutions</li>
            <li><b>Mr Domien AGTEN</b></li>
            <li>Country Manager BrightWolves South Africa</li>
            <li><b>Mrs Annie MUTAMBA (Moderator)</b></li>
            <li>Vice President Brussels- Africa Hub, Managing Director Meridia Partners</li>
          </ul>
        `,
      },
      {
        title: "Closing remarks",
        dateTime: "2023-06-30T19:25:00+02:00",
        description: `
          <ul>
            <li><b>Mrs Annie MUTAMBA</b></li>
          </ul>
        `,
      },
      {
        title: "Walking dinner",
        dateTime: "2023-06-30T19:30:00+02:00",
        description: `
        `,
      },
    ],
    photos: ["214d448c-de70-479a-9f2c-5818d068a8ec.jpeg","2d63e27f-0ced-4ac3-a5a9-13148ed3698b.jpeg","4b4debcf-cadb-4f25-8bb3-7debc0d1771c.jpeg","5504f1f8-7979-4243-9d3b-1fed00bd144a.jpeg","7de9c0b4-22ee-436d-9cfb-a7d485d3ff58.jpeg","929431ae-33dd-4a33-b21e-43ee73b92a9b.jpeg","d941efac-3dd0-4ccf-a972-373ca043b3e2.jpeg","de0707b2-2eb0-4588-bb94-bf3d53f302f6.jpeg"],
    organizers: [
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
    ],
  },
  {
    id: "uqWPVx3y",
    title: "Roundtable: Impact in Practice",
    dateTime: "2023-05-31",
    location: "The Merode, Brussels, Belgium",
    summary: "The Brussels-Africa Hub is cooperating with Europe Africa IP in the framework of an insightful roundtable dedicated to a constructive exchange with impact practitioners (Impact fund focused on Europe & Africa, Impact fund focused on Africa, and a FinTech focused on Ethiopia - Africa).",
    banner: "banner.jpg",
    description: `
      <p>
        The Brussels-Africa Hub is cooperating with Europe Africa IP in the framework of an insightful roundtable dedicated to a constructive exchange with impact practitioners (Impact fund focused on Europe & Africa, Impact fund focused on Africa, and a FinTech focused on Ethiopia - Africa).
      </p>
      <ul class="mt-5">
        <li><b>Dates:</b> Wednesday May 31st 2023 (14:00 - 17:00)</li>
        <li><b>Location:</b> Brussels, <a href="https://www.themerode.com/" target="_blank" rel="noopener noreferrer" class="text-blue-500"><b>The Merode</b> Blue Salon</a></li>
      </ul>
    `,
    agenda: [
      {
        title: "Welcome",
        dateTime: "2023-05-31T14:00:00+02:00",
        description: null,
      },
      {
        title: "The current status of Impact Investment",
        dateTime: "2023-05-31T14:15:00+02:00",
        description: `
          <ul>
            <li><a href="https://www.linkedin.com/in/thewodrosberhanu/" target="_blank" rel="noopener noreferrer" class="text-blue-500"><b>Thewodros Berhanu</b></a></li>
            <li>Founder & Managing Partner - Europe Africa IP</li>
            <li>Board Member - Brussels-Africa Hub</li>
          </ul>
        `,
      },
      {
        title: "Satgana",
        link: "https://www.satgana.com/",
        dateTime: "2023-05-31T14:25:00+02:00",
        description: `
          <ul>
            <li><b>Romain Diaz</b></li>
            <li>Founder & CEO - Satgana</li>
          </ul>
        `,
      },
      {
        title: "Zoscales",
        link: "https://www.zoscales.com/",
        dateTime: "2023-05-31T15:10:00+02:00",
        description: `
          <ul>
            <li><b>Ashenafi ALEMU</b></li>
            <li>Co-Founder & Managing Partner - Zoscales</li>
          </ul>
        `,
      },
      {
        title: "Arifpay",
        link: "https://arifpay.net/",
        dateTime: "2023-05-31T15:50:00+02:00",
        description: `
          <ul>
            <li><b>Bernard Laurendeau</b></li>
            <li>CEO Arifpay | Managing Partner Laurendeau  & Assoc.</li>
          </ul>
        `,
      },
      {
        title: "Q&A",
        dateTime: "2023-05-31T16:30:00+02:00",
        description: null,
      },
      {
        title: "Conclusion",
        dateTime: "2023-05-31T16:55:00+02:00",
        description: `
          <ul>
            <li><a href="https://www.linkedin.com/in/mouctar-bah-48a8a425/" target="_blank" rel="noopener noreferrer" class="text-blue-500"><b>Mouctar Bah</b></a></li>
            <li>President Brussels-Africa Hub</li>
            <li>Board Member Belgian Finance Center</li>
          </ul>
        `,
      },
      {
        title: "Networking Cocktail",
        dateTime: "2023-05-31T17:00:00+02:00",
        description: null,
      },
    ],
    photosInOneColumn: true,
    photos: ["0e1c7069-46ff-4b2f-ac1a-ce40d918cc1c.jpg","14778455-cd0c-4900-b3cb-ce590f11cc61.jpg","204c9828-64c8-4927-9cc6-fe6e7090d36b.jpg","366ee1bf-15d8-4f83-a058-1debe4e98ba6.jpg","455f617a-f575-40e9-ab5f-aa63a3d93d04.jpg","66b3024c-a908-4f2a-b790-73ee31a89219.png","7403d103-9d5f-49c9-a96f-07ef4bd4875c.jpg","9f57c08c-64e9-474a-b22c-e0ba76d502ca.jpg","bfb5411e-94a8-4260-90a7-b256929c20d8.jpg","d9b33731-86eb-40c2-8a2b-89aa514a28ab.jpg","eb895745-58e4-46d2-ac6f-1b3501689a2c.jpg","edf04261-eedd-4b80-8194-ff6306a60b55.jpg"],
    organizers: [
      {
        name: "Europe Africa IP",
        link: "https://www.europeafricaip.com",
        logo: process.env.PUBLIC_URL + "/img/partners/europe-africa-ip.jpg",
      },
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
    ]
  },
  {
    id: "4sMzn169",
    title: "Business with Ethiopia: Insights on the Ethiopian business ecosystem",
    dateTime: "2022-10-06",
    location: "Ethiopian Embassy, Etterbeek, Belgium",
    summary: "Insights on the Ethiopian business ecosystem. In-Person & Online.",
    banner: "Flag_of_Ethiopia.svg.png",
    description: `
      <p>
        The Brussels-Africa Hub is cooperating with the BelgoEthiopian Association and the Ethiopian Embassy in Brussels to organize an event on Insights on Doing Business with Ethiopia.
      </p>
      <p class="mt-5">
        <b>When?</b><br/>
        Thursday, October 6th PM<br/>
        From 14:00 to 17:00 (CEST)<br/>
      </p>
      <p class="mt-5">
        <b>Where?</b><br/>
        Embassy of Ethiopia in Brussels<br/>
        64, Avenue de Tervueren/Tervurenlaan<br/>
        1040 Etterbeek<br/>
        <a href="https://goo.gl/maps/xsiEF8NHqj1TAAE87" target="_blank" class="text-blue-500">Google Maps</a>
      </p>
      <p class="mt-5">
        <b>What?</b><br/>
        Insights on Doing Business with Ethiopia<br/>
        (Hybrid format: In-person & Online)
      </p>
    `,
    agenda: [
      {
        title: "Registration",
        dateTime: "2022-10-06T14:00:00+02:00",
      },
      {
        title: "Welcome",
        dateTime: "2022-10-06T14:30:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li>
              <b>Moderator: Thewodros Berhanu</b><br/>
              <a href="https://www.belgoethiopian.be/" class="text-blue-500" target="_blank">President of BelgoEthiopian Association</a> & <a href="https://brusselsafricahub.eu/about-us" class="text-blue-500" target="_blank">Board Member at Brussels-Africa Hub</a>
            </li>
          </ul>`,
      },
      {
        title: "Introduction",
        dateTime: "2022-10-06T14:35:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li>
              <b>H.E. Hirut Zemene</b><br/>
              <a href="https://ethiopianembassy.be/ambassador-welcome-note/" class="text-blue-500" target="_blank">Ambassador of Ethiopia to the BeNeLux countries & the EU institutions</a>
            </li>
            <li>
              <b>H.E. Stefaan Thijs</b><br/>
              <a href="https://twitter.com/JF_Parmentier/status/1555540543207268353?s=20&t=IsL5JcjXDM-wRiPlQS44kQ" class="text-blue-500" target="_blank">Ambassador of Belgium to Ethiopia, Djibouti, the AU, UNECA & IGAD</a>
            </li>
          </ul>`,
      },
      {
        title: "Presentation 1",
        dateTime: "2022-10-06T14:50:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li>
              <b>Lelise Neme</b><br/>
              <a href="https://www.investethiopia.gov.et/" class="text-blue-500" target="_blank">Commissioner at Ethiopian Investment Commission (EIC)</a>
            </li>
          </ul>`,
      },
      {
        title: "Presentation 2",
        dateTime: "2022-10-06T15:20:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li>
              <b>Shibeshi Bettemariam</b><br/>
              <a href="https://addischamber.com/about-us/" class="text-blue-500" target="_blank">Secretary General of Addis Ababa Chamber of Commerce and Sectoral Association (AACCSA)</a>
            </li>
          </ul>`,
      },
      {
        title: "Presentation 3",
        dateTime: "2022-10-06T15:45:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li>
              <b>Zeco Kassim</b><br/>
              <a href="http://www.puratos.com/" class="text-blue-500" target="_blank">General Manager Horn of Africa of PURATOS - Food Innovation</a>
            </li>
          </ul>`,
      },
      {
        title: "Presentation 4",
        dateTime: "2022-10-06T16:00:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li>
              <b>Guillaume Accarain</b><br/>
              <a href="https://www.bio-invest.be/en" class="text-blue-500" target="_blank">Private Equity Investment Officer at BIO - Belgian Development Finance Institution</a>
            </li>
          </ul>`,
      },
      {
        title: "Q&A Session",
        dateTime: "2022-10-06T16:15:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li>
              <b>Gemechis Tujuba</b><br/>
              <a href="https://www.ethiopianairlines.com/be" class="text-blue-500" target="_blank">Area Manager of BeNeLux Ethiopian Airlines</a>
            </li>
            <li>
              <b>Zemedeneh Negatu</b><br/>
              <a href="https://www.unido.org/persons/negatu-zemedeneh" class="text-blue-500" target="_blank">Global Chairman of FairFax Africa Fund</a>
            </li>
          </ul>`,
      },
      {
        title: "Closing remarks",
        dateTime: "2022-10-06T16:50:00+02:00",
        description: `
          <ul class="list-disc pl-5">
            <li>
              <b>Mouctar Bah</b><br/>
              <a href="https://brusselsafricahub.eu/about-us" class="text-blue-500" target="_blank">President of Brussels-Africa Hub</a> & <a href="https://www.belfinclub.be/fr/club.cfm#gouvernance" class="text-blue-500" target="_blank">Member Management Committee of Belgian Finance Club</a>
            </li>
          </ul>`,
      },
    ],
    videos: [
      "https://www.youtube.com/embed/Z2TDg9mlLj0",
    ],
    photos: ["076b2c8e-6f19-43aa-89f0-9f868d7f74a1.jpg","0f6ec3a5-d89a-4bfa-9108-0f5269359a97.jpg","146bd342-7f0f-47cd-bdc0-12f964f772f2.jpg","1a0bda70-a1a8-4d73-8188-e5924524e179.jpg","23e226da-de83-4db6-9918-d5e3ccd7a444.jpg","2d86a87f-b001-4e49-a6dd-7c958febf4e3.jpg","36958f08-eec5-4293-9de7-041591cc1bd8.jpg","6798f667-62c4-4612-94f9-a763a7955af7.jpg","702f2ed2-7517-40e3-a7d9-cb1a20a59d5e.jpg","88fc077d-cc3b-4bc1-a819-45bb2407eda4.jpg","d344fdf7-424f-4ed3-9e87-94902625e52e.jpg","e73333e2-62df-4e6d-af48-7c712919b8a6.jpg"],
    organizers: [
      {
        name: "Embassy of Ethiopia",
        link: "https://ethiopianembassy.be/en/",
        logo: process.env.PUBLIC_URL + "/img/partners/ethiopian-embassy.png",
      },
      {
        name: "BelgoEthiopian",
        link: "https://www.belgoethiopian.be/",
        logo: process.env.PUBLIC_URL + "/img/partners/belgoethiopian.png",
      },
      {
        name: "Brussels-Africa Hub",
        link: "https://www.brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
    ],
    partners: [
      {
        name: "BECI",
        link: "https://www.beci.be/category/international/",
        logo: process.env.PUBLIC_URL + "/img/partners/beci.jpg",
      },
      {
        name: "Awex",
        link: "https://www.awex.be/",
        logo: process.env.PUBLIC_URL + "/img/partners/awex.jpg",
      },
      {
        name: "Flanders Investment & Trade",
        link: "https://welcome.flandersinvestmentandtrade.com/en",
        logo: process.env.PUBLIC_URL + "/img/partners/fit.jpg",
      },
      {
        name: "hub.brussels",
        link: "https://hub.brussels/en/international-2/africa/",
        logo: process.env.PUBLIC_URL + "/img/partners/hub-brussels.png",
      },
      {
        name: "CBL-ACP",
        link: "https://cbl-acp.be/en/home/",
        logo: process.env.PUBLIC_URL + "/img/partners/cbl-acp.jpg",
      },
    ],
  },
  {
    id: "SDXfLLUr",
    title: "INSEAD 'Valuation and Risk Management in Banking' executive programme",
    dateTimeFrom: "2022-04-25",
    dateTimeTo: "2022-04-29",
    location: "Kigali Convention Centre, Kigali, Rwanda",
    summary: "In today's constantly shifting global economy and turbulent business environment, organisations face making financial decisions that are more complex and challenging than ever before...",
    banner: "INSEAD.jpg",
    description: `
      <p>
        In today's constantly shifting global economy and turbulent business environment, organisations face making financial decisions that are more complex and challenging than ever before. Differences in regulation, taxation, political risk and governance quality all have an impact on the way such decisions should be made.
      </p>
      <p class="mt-5">
        Company valuations, mergers and acquisitions and IPOs are no exception. With an ever shifting global corporate environment, how do you ensure that you have the valuation skills needed to best advise your clients on how to create shareholder value?
      </p>
      <p class="mt-5">
        And as the banking world is shifting from an overriding concern for growth to a preoccupation with risk control and long-term sustainable value creation, how do you help your clients measure risk?
      </p>
      <p class="mt-5">
        Held in partnership with Brussels Africa Hub, Rwanda Bankers' Association, Rwanda Finance Limited and Rwanda Development Board, the <b>Valuation and Risk Management in Banking</b> programme will shine a light on the latest valuation methodologies used in the context of major investment decisions such as acquisitions and IPOs.
      </p>
      <p class="mt-5">
        Over 4 days, you will discuss valuation methodologies as well as asset and liability management and the control of risk and long-term value creation.
      </p>
      <p class="mt-5">
        By the end of the programme you will have a better understanding of how to value companies, how to estimate the cost of capital in emerging markets and an understanding of the sources of value-creation in banking.
      </p>
      <iframe class="mt-5 max-w-full" width="560" height="315" src="https://www.youtube.com/embed/Sxu0KhOeVS0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    `,
    agendaIntro: `
      <p>
        The first Module <b><i>Valuation and Capital Markets</i></b> deals with company valuation in various context such as Mergers and Acquisitions and IPOs. Different valuation methodologies will be discussed although the emphasis is on DCF. The topics will be illustrated with case studies including the IPO of CIMERWA.
      </p>
      <p class="mt-5">
        The second Module <b><i>Risk Management in Banking</i></b> teaching risk management and value creation using the ALCO Simulation. As the banking world is shifting from an overriding concern for growth to a preoccupation with risk control and long-term sustainable value creation, knowledge of Asset & Liability Management (ALM) is becoming a necessity for all bankers accountable for the results of a profit center.
      </p>
    `,
    agenda: [
      {
        title: "Module 1: Valuation and Capital Markets",
        description: `
          The objective Module 1 is to discuss Valuation methodologies in the context of major investment decisions such as acquisitions and IPOs. Special attention is given to estimating whether valuations are realistic or overly optimistic. We will spend time on how to estimate discount rates in the context of emerging markets and the relevance of corporate governance in mitigating risks. We will also send time on institutional details, in particular on the relative benefits and costs of different methods to take a company public. Topics include:
          <ul class="list-disc pl-5">
            <li class="mt-2>Valuation</li>
            <li class="mt-2">The Cost of Capital and Capital Structure</li>
            <li class="mt-2">Initial Public Offerings</li>
          </ul>
        `,
      },
      {
        title: "Module 2: Risk Management in Banking",
        description: `
          The objective of the second module is to discuss Asset & Liability Management, the control of risks and long-term value creation. Special attention is given to key-performance indicators, economic capital allocation, advanced fund transfer pricing, credit risk, interest rate and liquidity risks, and implications of the Final Basel 3 regulations. Topics include:
          <ul class="list-disc pl-5">
            <li class="mt-2">Asset & Liability Management, an Introduction to Corporate Financial Goals and Value Center Management. Advanced Fund Transfer Pricing (FTP) and the Liquidity Coverage Ratio (LCR)s</li>
            <li class="mt-2">Economic Capital, Value-Based Loan Pricing, and Securitisation</li>
            <li class="mt-2">The Control of Interest Rate and Liquidity Risks (the 'Banking' book): The 'Earnings-at-Risk'. Gap vs Simulation Models</li>
            <li class="mt-2">From Basel 2 to Basel 4 Credit Risk Evaluation and Current Expected Loan Loss Provisioning (CECL, IFRS9)</li>
            <li class="mt-2">Business Portfolio Diversification, Friend or Foe</li>
          </ul>
        `,
      },
    ],
    programDirectors: [
      {
        name: 'Theo Vermaelen',
        image: process.env.PUBLIC_URL + '/img/events/2022-insead-valuation-and-risk-management-in-banking-executive-programme/directors/theo-vermaelen.jpg',
        profileURL: 'https://www.linkedin.com/in/theo-vermaelen-aa394b13/',
        position: 'Professor of Finance and Investment Banking',
        bio: "Theo Vermaelen teaches in MBA, PhD and Executive Education programmes. He is a graduate from the Department of Applied Economics at the Catholic University of Leuven (Commercial Engineer) and obtained an MBA and PhD in Finance from the Graduate School of Business, University of Chicago."
      },
      {
        name: 'Jean Dermine',
        image: process.env.PUBLIC_URL + '/img/events/2022-insead-valuation-and-risk-management-in-banking-executive-programme/directors/jean-dermine.jpg',
        profileURL: 'https://www.linkedin.com/in/jean-dermine-2078a728/',
        position: 'Professor of Banking and Finance',
        bio: "Jean Dermine is a Professor of Banking and Finance at INSEAD. He holds Doctorat en Sciences Economiques from the Université Catholique de Louvain and Master of Business Administration from Cornell University. He is the author of numerous articles and books on asset and liability management, European financial markets, and the Theory of Banking."
      },
    ],
    targetAudience: `
      <ul class="list-disc pl-5">
        <li class="mt-2">Banks Corporate &amp; Retail bankers</li>
        <li class="mt-2">Insurance</li>
        <li class="mt-2">Investment Funds &amp; Advisory</li>
        <li class="mt-2">Private sector listed in the stock exchange • Bank treasurers and CFOs</li>
        <li class="mt-2">Analysts</li>
        <li class="mt-2">Risk managers and ALM specialists • Auditors</li>
        <li class="mt-2">Central Bankers and Supervisors</li>
        <li class="mt-2">Board members</li>
      </ul>
    `,
    photos: ["37343c67-a4a9-4d71-b767-678e78771ccf.jpg","37d0ae26-685d-48bf-88ec-9c438de7ff39.jpg","3ebb2913-63d1-465a-bd32-25f569fcbddd.jpg","4dd4d0cb-7765-4fae-b49b-85b6fece1efd.jpg","57541907-10e1-477c-b908-c07d907d7161.jpg","9b68a9a6-bdee-4bdb-87c7-332ccc726aa1.jpg","a9e45a17-32af-471a-97ad-1a2052e6ee98.jpg","ac9f1a96-b0ef-4140-a86d-0b703175423c.jpg","ae0de3c0-ef88-4a52-af67-6223a286ceae.jpg","c04244cd-8f7a-45a2-8ee8-f37c6ea33a95.jpg","c9b45e57-63e4-4ede-8741-6cccb16ef866.jpg","e21ea920-b4b1-42b3-b8dc-60bc269f84c9.jpg","e8be1f10-cfe3-4cc9-97f6-9034c5ad364a.jpg","f7e111b0-d2a7-4605-9bff-9a75bd7387d9.jpg"],
    partners: [
      {
        name: "INSEAD",
        link: "https://www.insead.edu/",
        logo: process.env.PUBLIC_URL + "/img/partners/insead.png",
      },
      {
        name: "Kigali International Financial Centre",
        link: "https://www.rfl.rw/",
        logo: process.env.PUBLIC_URL + "/img/partners/kigali-international-financial-centre.jpg",
      },
      {
        name: "Rwanda Bankers' Association",
        link: "https://rba.rw/",
        logo: process.env.PUBLIC_URL + "/img/partners/rwanda-bankers-association.jpg",
      },
      {
        name: "Rwanda Finance Limited",
        link: "https://www.rfl.rw/",
        logo: process.env.PUBLIC_URL + "/img/partners/rwanda-finance-limited.jpg",
      },
      {
        name: "Rwanda Development Board",
        link: "https://rdb.rw/",
        logo: process.env.PUBLIC_URL + "/img/partners/rwanda-development-board.jpg",
      },
    ],
  },
  {
    id: "3T2vFq1q",
    title: "Investing in Ethiopia: A private equity perspective",
    dateTime: "2019-11-28",
    location: "Ethiopian Embassy, Etterbeek, Belgium",
    summary: "Ethiopia is a big, yet undeveloped market with several sectors in their infant stage, offering opportunities for Private Equity (PE) and impact investors. Over the years PE firms in Ethiopia focused on two...",
    banner: "Flag_of_Ethiopia.svg.png",
    description: `
      <p>
        Ethiopia is a big, yet undeveloped market with several sectors in their infant stage, offering opportunities for Private Equity (PE) and impact investors.
      </p>
      <p class="mt-5">
        Over the years PE firms in Ethiopia focused on two notable sectors that research shows will remain the main opportunities baskets in the country:
      </p>
      <ul class="mt-5 list-disc pl-5">
        <li>
          <b>Fast-moving consumer goods (FMCG):</b> there is a huge opportunity in adding value to locally-sourced commodities and exporting the finished products internationally, by leveraging on Ethiopia’s competitive advantages such as attractive labour costs, access to power, as well as some very attractive tax regimes and incentives.
        </li>
        <li>
          <b>Agri-business:</b> With 74 million ha of arable land, diverse topography and agro-climatic zones, fertile soils and water availability, Ethiopia is an ideal destination for commercial farming and other agri-business activities.
        </li>
      </ul>
      <p class="mt-5">
        Beyond those traditional sectors, opportunities abound in several others such as services, healthcare, technology, and real estate.
      </p>
      <p class="mt-5">
        In this inaugural event, the Ethiopian Embassy and the Brussels-Africa Hub are pleased to welcome you to the majestuous premises of the Embassy to discuss private equity investments in Ethiopia with guests who were involved in the major deals in recent years.
      </p>
      <iframe class="mt-5 max-w-full" width="560" height="315" src="https://www.youtube.com/embed/J6gwRiVmHF8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    `,
    agenda: [
      {
        title: "Registration",
        dateTime: "2019-11-28T09:30:00+01:00",
        description: "",
      },
      {
        title: "Panel event",
        dateTime: "2019-11-28T10:00:00+01:00",
        description: `
          Topics:
          <ul class="mt-1 list-disc pl-5">
            <li>Ethiopia: an African champion</li>
            <li>Private Equity returns</li>
            <li>Incentives for PE investments</li>
            <li>An Ethiopian deal from sourcing to exiting (perspective from a PE firm and from an investee/seller)</li>
          </ul>
        `,
      },
    ],
    speakers: `
      <p>          
        <b>Welcome speaker:</b> H.E. Ambassador Grum Abay, Special Envoy, Extraordinary and Plenipotentiary of the FDRE to Belgium, Luxembourg and E.U. institutions<br />
        <b>Moderator:</b> M. Belachew Mekuria, former Commissioner of the Ethiopian Investment Commission<br />
        <b>Panellists:</b><br />
        <ul class="mt-1 list-disc pl-5">
          <li>Mr. Zemedeneh Negatu: Chairman at Fairfax Africa Fund, former Managing Partner at EY Ethiopia (<a href="https://www.unido.org/node/119064" class="text-blue-500" target="_blank">profile</a>)</li>
          <li>Mr. Saad Aouad: Founder &amp; Chief Investment Officer of 54 Capital (<a href="https://www.linkedin.com/in/saad-aouad-89693315/" class="text-blue-500" target="_blank">profile</a>)</li>
          <li>Mr. Viale Thierry: President Europe of Ontex (<a href="https://www.linkedin.com/in/thierryviale/" class="text-blue-500" target="_blank">profile</a>)</li>
        </ul>
      </p>
    `,
    targetAudience: `
      <p>
        This event is aimed at decision-makers of the European investment community interested in new opportunities in emerging/frontier markets in general, and in Africa in particular.
      </p>
    `,
    photos: ["00130f5a-252a-4b9d-8ed9-541f336556ea.jpg","02e810d7-4f80-4338-bd9b-e4403725749a.jpg","0f3ce044-c12e-4151-acd4-e069fd0d8946.jpg","1987ecd6-ad8a-475e-a9f7-0eba1e874399.jpg","2c292e2b-fd75-4699-baa9-a27ce99e487c.jpg","3155914f-ef65-4e0e-aaa6-b41847a9fe47.jpg","3542c410-d06a-47aa-b5ff-36130a24fe0c.jpg","42f4548b-9a9f-45d7-b3a4-61532dba8a34.jpg","549b0517-60c7-498d-8269-a2e6a19fd7c4.jpg","5cfdfd27-78ac-4c7e-9770-a9169a7dabe3.jpg","5ecb1fb9-3913-433c-8122-52a15a0d4b92.jpg","604c40a4-764f-42b5-9c2e-a2052c97001e.jpg","7a9b3ea6-2aaf-4c2a-9707-c854284a3b2a.jpg","90910dd1-d0fd-4227-be64-e53f90b9a7d2.jpg","9159ecf1-3c81-4959-a8a5-287b02509527.jpg","9570b35b-c023-4d6b-9d2c-694f284f9e00.jpg","b94125cd-83ed-4245-8246-20038038bfde.jpg","d9ec5e7e-ebaa-4d4a-a8bd-2d978adba5eb.jpg","e5f2ea61-5fef-4098-b2bd-b4118ec24163.jpg","f1cc73fb-8d7d-47e7-afb9-725a2d9cb210.jpg","f6b8e9a8-3605-4417-9af4-d861c0607f03.jpg"],
    partners: [
      {
        name: "Embassy of Ethiopia",
        link: "https://ethiopianembassy.be/en/",
        logo: process.env.PUBLIC_URL + "/img/partners/ethiopian-embassy.png",
      },
    ],
  },
  {
    id: "OH7tM0pG",
    title: "Potato industry: Belgium - Rwanda",
    dateTimeFrom: "2019-09-25",
    dateTimeTo: "2019-09-27",
    location: "Belgium",
    summary: "The Belgian potato industry tour brought a Rwandan delegation to Belgium to explore one of the world's most advanced potato sectors, where strong farmer partnerships, cutting-edge technology, and research-driven innovation drive a highly efficient and competitive value chain.",
    banner: process.env.PUBLIC_URL + "Flag_of_Rwanda.svg.png",
    description: `
      <p>
        Belgium is renowned as a global leader in potato production and processing, setting high standards in innovation, quality, and efficiency. A recent visit to key industry players provided valuable insights into best practices that can be applied to strengthen potato value chains elsewhere.
      </p>
      <p class="mt-5">
        One of the standout lessons was the integration of processing and farming through strategic partnerships. Leading processors work closely with farmers, using structured contracts that ensure a stable supply while providing financial security for growers. Advanced storage and quality control methods help optimize yield and minimize waste, making the entire system highly efficient. Furthermore, specialized research centers contribute by offering real-time market data, disease monitoring, and tailored agricultural guidance to farmers, ensuring the sector remains competitive.
      </p>
      <p class="mt-5">
        Technology also plays a crucial role in Belgium’s potato industry. From AI-powered monitoring systems and drones used for precision farming to high-tech machinery that streamlines planting and harvesting, innovation drives efficiency at every stage. The emphasis on research, sustainable farming practices, and cooperative business models offers valuable lessons for emerging markets looking to enhance their potato production and processing capabilities. By adopting similar strategies, the sector can become more resilient, productive, and ready to meet growing market demands.
      </p>
    `,
    agenda: [
      {
        title: "Day 1: Agristo - Wielsbeke",
        description: `
          <p>
            The Rwandan delegation visited Agristo, a leading Belgian potato processor, where co-founder Antoon Walleys shared insights into the company’s evolution from a small operation in 1986 to a global producer with facilities in Belgium, the Netherlands, and India. The delegation explored Agristo’s farmer partnerships, contract models, and quality control measures that ensure efficiency and traceability. A guided factory tour showcased the full production cycle, from raw potato intake and hygiene protocols to peeling, cutting, baking, and packaging for global export, highlighting how market-driven strategies and technological advancements have positioned the company as an industry leader.
          </p>
          <a href="https://www.agristo.com/en" target="_blank" rel="noopener noreferrer" class="text-blue-500">https://www.agristo.com/en</a>
        `,
      },
      {
        title: "Day 1: Dewulf - Roeselare",
        description: `
          <p>
            Dewulf, a leading manufacturer of agricultural machinery, specializes in soil cultivation, planting, harvesting, and storage solutions. Following its merger with Miedema Winsum, the company now provides equipment for all phases of the potato cycle, with production facilities in Belgium, the Netherlands, and Romania. Machines are designed for flexibility, available in both trailer and self-propelled versions, and can be adapted for other crops like carrots. A key focus is on farmer independence, as machines are built using standard components, allowing easy repairs without relying solely on Dewulf. The visit also highlighted the role of contractor companies in Europe, which own and operate agricultural machinery on behalf of multiple farmers, optimizing costs and efficiency in modern farming.
          </p>
          <a href="https://www.dewulfgroup.com/en" target="_blank" rel="noopener noreferrer" class="text-blue-500">https://www.dewulfgroup.com/en</a>
        `,
      },
      {
        title: "Day 1: Proefcentrum voor de Aardappelteelt (Test Center for Potato Cultivation) - Kruishoutem",
        description: ` 
          <p>
            PCA (Proefcentrum voor de Aardappelteelt) plays a crucial role in supporting potato growers in Flanders by providing market insights, field treatment recommendations, and disease monitoring. The organization collects and publishes weekly market price data in coordination with its Walloon counterpart and offers targeted agronomic advice based on data from its 48 weather stations. Funded by government contributions, membership fees, and third-party research projects, PCA serves 85% of Flanders’ potato-growing area. Its research efforts focus on optimizing farming practices, while its early warning system helps members respond quickly to potential threats. Additionally, PCA collaborates on research projects and offers tailored studies to support industry advancements.
          </p>
          <a href="https://www.pcainfo.be" target="_blank" rel="noopener noreferrer" class="text-blue-500">https://www.pcainfo.be</a>
        `,
      },
      {
        title: "Day 2: ILVO (Research Institute for Agriculture, Fisheries and Food) - Merelbeke",
        description: `
          <p>
            ILVO, a leading research institute for agriculture, fisheries, and food, focuses on plant health and serves as a European reference laboratory for nematodes and bacteria. Funded partly by the Flemish government and research projects, ILVO conducts studies and provides services to improve crop management. A demonstration showcased the use of Artificial Intelligence and drones in precision farming, highlighting their role in plant monitoring and disease detection. Further insights were provided on nematodes, detailing their impact on potato crops, soil analysis techniques, and laboratory methods used for early detection and management strategies.
          </p>
          <a href="https://www.ilvo.vlaanderen.be/default.aspx?tabid=6469&language=en-US" target="_blank" rel="noopener noreferrer" class="text-blue-500">https://www.ilvo.vlaanderen.be/default.aspx?tabid=6469&language=en-US</a>
        `,
      },
      {
        title: "Day 2: Warnez Potato - Tielt",
        description: `
          <p>
            Warnez, a family-owned company in the potato sector since 1950, has grown from a small washing and packaging operation to a comprehensive processing facility with dedicated departments for transport, storage, cleaning, packaging (including organic potatoes), peeling, and cooking. As a partner in a Walloon potato cooperative, the company collaborates closely with growers, offering flexible contract models to adapt to market fluctuations. A guided tour of the plant highlighted advanced cold storage techniques, the cleaning and washing process, and quality control procedures, which combine manual inspection with automated systems to ensure high standards in packaging and distribution.
          </p>
          <a href="http://www.warnezpotatoes.be/en" target="_blank" rel="noopener noreferrer" class="text-blue-500">http://www.warnezpotatoes.be/en</a>
        `,
      },
    ],
    videos: [],
    photos: [],
    organizers: [
      {
        name: "Brussels-Africa Hub",
        link: "https://brusselsafricahub.eu",
        logo: process.env.PUBLIC_URL + "/img/partners/brussels-africa-hub.jpg",
      },
    ],
  },
  {
    id: "lLctO3YA",
    title: "1st EU Africa Property Investment Conference",
    dateTime: "2017-11-21",
    location: "The Hotel, Brussels, Belgium",
    summary: "As one of the fastest growing economies in the world, Africa offers immense opportunities for European investors. The real estate market is undergoing tremendous transformation...",
    banner: "banner.jpg",
    description: `
      <p>
        As one of the fastest growing regions in the world, Africa offers immense opportunities for European investment.
      </p>
      <p class="mt-5">
        The real estate market is undergoing tremendous transformation. Major retail and hotel brands are entering in response to change in consumer tastes, new office complexes are rising to support growing businesses, and new residential homes are being built to meet the needs of a burgeoning middle class.
      </p>
      <p class="mt-5">
        This event will highlight the transformation in this region and avenues to invest.  Attendees will have the opportunity to speak with leaders of companies driving property growth in Africa.
      </p>
    `,
    agenda: [
      {
        title: "Welcome drink",
        dateTime: "2017-11-21T18:00:00+01:00",
        description: "",
      },
      {
        title: "Introduction by William McKenzie",
        dateTime: "2017-11-21T18:15:00+01:00",
        description: `
          <p>
            William is an African Infrastructure and Construction sector expert bringing deep understanding of the regional business, political and project environment. Currently based in South Africa, he provides strategic advice to clients delivering projects across the African continent.
          </p>
          <p>
            He previously held key leadership positions for the US engineering and construction firm, Bechtel, where he was Africa Infrastructure Business Development Manager and Gabon Country Manager. Throughout this period, he developed relationships with African Presidents and Ministers, as well as industry and banking sector leaders. Prior to Bechtel, he served as a military officer in the US Air Force, conducting Foreign Affairs and Global Procurement.
          </p
          He holds an MBA from London Business School and a Bachelors in International Affairs from the United States Air Force Academy.
        `,
      },
      {
        title: "Hafeez Giwa - African Commercial and Retail Development",
        dateTime: "2017-11-21T18:30:00+01:00",
        description: "Hafeez Giwa is a Managing Partner of HC Capital Properties and is based in London.<br><br>Prior to HC Capital Properties, Hafeez was an Investment Principal in the London office of Actis - Africa Real Estate where he focused on West African real estate investment opportunities exceeding an aggregate value of USD$650MM. Before joining Actis, he worked in the real estate investment banking and principal investing divisions of Morgan Stanley in New York and London.<br><br>Hafeez holds an MBA from the Harvard Business School and a BA in Finance (with honours) from Howard University where he was a Morgan Stanley - Richard B. Fisher Scholar.",
      },
      {
        title: "Kameel Keshav - Inkunzi Student Accommodation Fund",
        dateTime: "2017-11-21T19:00:00+01:00",
        description: "Kameel is a qualified chartered accountant. He has diverse experience that extends across the Financial Services, Consulting, FMCG and Mining industries all with global listed entities. A large component of this experience extends to direct functional responsibility across Africa, Middle East and Continental Europe.<br><br>Kameel has also always had a strong commitment to transformation and diversity in the workplace having obtained course certification from an International US University in this field.<br><br>Prior to his appointment to the Ikunzi board, Kameel was the chief financial officer of Rebosis Property Fund Limited and the chief executive officer of Ascension Properties Limited. He also served on the board of New Frontier Properties in the UK as a non-executive director.",
      },
      {
        title: "Short break",
        dateTime: "2017-11-21T19:30:00+01:00",
        description: "",
      },
      {
        title: "Diogo Saraiva de Ponte - Investing in Africa",
        dateTime: "2017-11-21T19:45:00+01:00",
        description: "Diogo is a Board Member of the Atlantico Financial Group and Advisor of the Board of Odell Global Investors. Previously he was the Head of Private Equity at ATLANTICO Europa and a member of ATLANTICO's Investment Banking team, having joined the bank in 2009.<br><br>He has worked in the Private Equity division of a private banking financial institution in Portugal where he managed around € 1 billion of assets in a wide range of sectors and geographies. He began his professional career in the investment banking team in the largest private held bank in Portugal - Millennium BCP Investimento.<br><br>Diogo has a degree in Business Administration from Universidade Católica Portuguesa in Lisbon, Portugal.",
      },
      {
        title: "Christophe Evers - TEXAF",
        dateTime: "2017-11-21T20:15:00+01:00",
        description: "A MA Business Administration from the Solvay Brussels School of Economics and Management, Christophe Evers began his career with Umicore.<br><br>In 1989 he joined Cobepa, where he became Chief Financial Officer and a member of the Executive Committee. In 2001 he became a member of Bpost's Executive Committee in charge of business development, real estate and all activities outside of Mail and Retail. From 2004 to 2010 he was a partner in the investment bank Drakestar Partners, specialized in technology.<br><br>Christophe Evers is a professor at the Solvay Brussels School and author of several financial publications.",
      },
      {
        title: "Closing reception",
        dateTime: "2017-11-21T20:45:00+01:00",
        description: "",
      }
    ],
    videos: [
      "https://www.youtube.com/embed/zUVisnwsJKQ",
    ],
    photos: ["0384ae89-1f33-493b-97a5-ad720449955f.jpg","23cfb90f-fb77-4ecd-a167-66b200a5a98b.jpg","31284ed7-21d9-4533-92c0-a99c717beb76.jpg","490559e3-34ca-4cc4-a507-06b5f2d2c72d.jpg","53616358-8536-429b-810a-94d83a36c00a.jpg","7c7c8bab-94f8-48eb-bf99-a0bf60d11e79.jpg","9faf6268-e2ab-4826-8360-0d2826a6915f.jpg","a985ed4b-4549-44d5-abcc-3c57e151a7ee.jpg","c6718d2b-db1a-41c5-99b1-53693f67e6b4.jpg","cf8b4dc0-357e-459d-9ea9-c88dd494ccde.jpg","ea2e27c9-2919-4280-8fd7-2630635f8afe.jpg","f9453130-3b51-43bb-9b7e-e41f5040383b.jpg"],
    partners: [
      {
        name: "LuxAfrica",
        link: "https://luxafrica.wildapricot.org/",
        logo: process.env.PUBLIC_URL + "/img/partners/luxafrica.png",
      },
    ],
    sponsors: [
      {
        name: "TEXAF",
        link: "http://www.texaf.be",
        logo: process.env.PUBLIC_URL + "/img/partners/texaf.png",
      },
    ],
  },
];

export default events;